<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2024-04-17 14:24:33
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2025-08-21 16:40:06
 * @FilePath: \newsmartmapout\src\views\Watch.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="watchBody">
    <div class="dizaiLedgon" v-show="isShowdaizailegon">
      <div class="dizaiLedgonTitle">地灾预警图例</div>
      <div class="dizaiLedgonitem">
        <div class="dizaiLedgonitemLeft" style="background-color:#FBFF00"></div>
        <div class="dizaiLedgonitemright" >黄色预警(风险较高)</div>
      </div>
      <div class="dizaiLedgonitem">
        <div class="dizaiLedgonitemLeft" style="background-color:#E59800"></div>
        <div class="dizaiLedgonitemright" >橙色预警(风险高)</div>
      </div>
      <div class="dizaiLedgonitem">
        <div class="dizaiLedgonitemLeft" style="background-color:#E80000"></div>
        <div class="dizaiLedgonitemright" >红色预警(风险很高)</div>
      </div>
     
    </div>
    <div class="optionSet2" v-show="!isShowLengdhBox" @click="isShowLengdhBox=true">显示图例</div>
    <div id="map" style="width:100%;height:100%;position: absolute;"></div>
    <div class="echartsBox" :style="{left: tranLeft, top: tranTop}" v-show="isShowEchartsBox">
      <div style="width:100%;height:100%" ref="echartsbox"></div>
      <div class="closeBoxImg3" @click.stop="isShowEchartsBox=false">
        <img src="../assets/Frame_1714.png" style="width:100%;height:100%" alt />
      </div>
    </div>
    <div
      class="showWaringBoxBtn"
      v-show="!isShowWartherWaring"
      @click.stop="isShowWartherWaring=true"
    >
      <i class="el-icon-d-arrow-right"></i>
    </div>
    <div class="showWaringBoxBtn2" v-show="!isShowEarthquake" @click.stop="isShowEarthquake=true">
      <i class="el-icon-d-arrow-right"></i>
    </div>
    <div class="showWaringBoxBtn3" v-show="!isShowPlaceWaring" @click.stop="isShowPlaceWaring=true">
      <i class="el-icon-d-arrow-right"></i>
    </div>

    <el-dialog title="透明度调整" :visible.sync="showoptSetBox" width="30%">
      <el-slider v-model="optData" :format-tooltip="formatTooltip"></el-slider>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showoptSetBox = false">取 消</el-button>
        <el-button type="primary" @click="changeoptDataHandel">确 定</el-button>
      </span>
    </el-dialog>
    <div class="warningInfoText">
      <div class="warningInfoTextItem">
        <!-- <span>当前您所在区域正在发生红色暴雨过程,附近区域可能发生滑坡，请注意安全</span> -->
        <span>{{warningTextStr}}</span>
      </div>
      <!-- <span>{{warningTextStr}}</span> -->
      <!-- <span>当前您所在区域正在发生红色暴雨过程,附近区域可能发生滑坡，请注意安全</span> -->
    </div>
    <div class="leftConBox">
      <!-- <div class="warningBox" v-show="false"> -->
      <!-- <div class="warningBox" v-show="isShowPlaceWaring">
        <div class="closeBoxImg2" @click.stop="isShowPlaceWaring=false">
          <img src="../assets/Frame_1714.png" style="width:100%;height:100%" alt />
        </div>
        <div class="weatherTitle">
          <div class="weatherTitText">地质预警</div>
        </div>
        <div class="warningMainBox" @click="handleClick($event)">
          <vue-seamless-scroll :data="waringListplace" :class-option="classOption" class="warp">
            <div class="warningMainBoxItem" v-for="item in waringListplace" :key="item.time">
              <div>{{item.text}}</div>
              <div class="warningBtn" :data-obj="JSON.stringify(item)">查看</div>
            </div>
          </vue-seamless-scroll>
         
        </div>
      </div>-->
      <!-- <div class="warningBox" v-show="isShowPlaceWaring">
        <div class="closeBoxImg2" @click.stop="isShowPlaceWaring=false">
          <img src="../assets/Frame_1714.png" style="width:100%;height:100%" alt />
        </div>
        <div class="weatherTitle">
          <div class="weatherTitText">地灾预警历史查询</div>
        </div>
        <div class="warningMainBox" @click="handleClick($event)">
          <vue-seamless-scroll :data="waringListplace" :class-option="classOption" class="warp">
            <div class="warningMainBoxItem33" v-for="item in waringListplace" :key="item.time">
              <div>起报时间:{{item.datetime}},预报时间:{{item.forcastTime}}</div>
              <div class="warningBtn" :data-obj="JSON.stringify(item)">查看</div>
            </div>
          </vue-seamless-scroll>
        </div>
      </div> -->
       <div class="warningBox" v-show="isShowPlaceWaring">
        <div class="closeBoxImg2" @click.stop="isShowPlaceWaring=false">
          <img src="../assets/Frame_1714.png" style="width:100%;height:100%" alt />
        </div>
        <div class="weatherTitle">
          <div class="weatherTitText">地灾预警历史查询</div>
        </div>
        <div class="warningMainBox" @click="handleClick3($event)">
          <vue-seamless-scroll :data="dizaiwarningList" :class-option="classOption" class="warp">
            <div class="warningMainBoxItem33" v-for="item in dizaiwarningList" :key="item.time">
              <div>{{item.time}}20地灾预警</div>
              <div class="warningBtn" :data-obj="JSON.stringify(item)">查看</div>
            </div>
          </vue-seamless-scroll>
        </div>
      </div>
      <div class="Earthquake" v-show="isShowEarthquake">
        <div class="closeBoxImg2" @click.stop="isShowEarthquake=false">
          <img src="../assets/Frame_1714.png" style="width:100%;height:100%" alt />
        </div>
        <div class="weatherTitle">
          <div class="weatherTitText">地震预警</div>
        </div>
        <div class="warningMainBox2">
          <vue-seamless-scroll :data="EarthquakeDataList" :class-option="classOption" class="warp">
            <div class="warningMainBoxItem" v-for="item in EarthquakeDataList" :key="item.time">
              <div>{{item.place}}</div>
              <div class="warningBtn" @click="showEarthquakePrint(item)">查看</div>
            </div>
          </vue-seamless-scroll>
        </div>
      </div>
      <!-- <div class="weatherBox" v-show="isShowWartherWaring">
        <div class="closeBoxImg2" @click.stop="isShowWartherWaring=false">
          <img src="../assets/Frame_1714.png" style="width:100%;height:100%" alt />
        </div>
        <div class="weatherTitle">
          <div class="weatherTitText">气象预警</div>
        </div>
        <div class="warningMainBox">
          <vue-seamless-scroll :data="waringList" :class-option="classOption" class="warp">
            <div
              class="warningMainBoxItem"
              :style="{color:item.severity}"
              v-for="item in waringList"
              :key="item.sendTime"
            >
              <div>{{item.headline}}</div>
              <div class="warningBtn" @click="showwaringDelInfo(item)">查看</div>
            </div>
          </vue-seamless-scroll>
        </div>
      </div>-->
      <div class="warningBoxf22">
        <div class="weatherTitle">
          <!-- <div class="weatherTitText">预警管理</div> -->
          <div class="weatherTitText">当前气象预警</div>
        </div>
        <div class="warningMainBox33">
          <!-- <div class="warningMainBox33Item" v-for="item in 4">{{item}}</div> -->
          <div class="warningMainBox33Item">
            <div class="item1">{{warningcountData[0].value}}</div>
            <div class="item2">{{warningcountData[1].value}}</div>
            <div class="item3">{{warningcountData[2].value}}</div>
            <div class="item4">{{warningcountData[3].value}}</div>
          </div>
          <div class="waringtTitle">
            <div class="item1">蓝色预警</div>
            <div class="item2">黄色预警</div>
            <div class="item3">橙色预警</div>
            <div class="item4">红色预警</div>
          </div>
          <!-- <video
            muted
            autoplay="autoplay"
            preload="auto"
            playsinline
            loop
            src="../assets/warnBck.webm"
            type="video/webm"
            class="mywivewBox2"
          />-->
          <!-- <vue-seamless-scroll :data="waringList2" :class-option="classOption" class="warp">
            <div class="warningMainBoxItem" v-for="item in waringList2" :key="item.time">
              <div>{{item.headline}}</div>
              <div class="warningBtn" @click="showwaringDelInfo(item)">详情</div>
            </div>
          </vue-seamless-scroll>-->
          <!-- <div id="roundEchartBox"></div> -->
        </div>
      </div>
    </div>

    <div class="rightConBox">
      <!-- <div class="videoBox">
        <div class="weatherTitle">
          <div class="weatherTitText">预警推算</div>
        </div>
        <div class="videoMainBox">
          <div class="warningInfoMainBox" v-for="item in extrapolateData" :key="item.forcastTime">
            <div class="warningInfoMainBoxItem">
              <div class="itemLeftBox">起报时间</div>
              <div class="itemRightBox">{{item.datetime}}</div>
            </div>
            <div class="warningInfoMainBoxItem">
              <div class="itemLeftBox">预报时间</div>
              <div class="itemRightBox">{{item.forcastTime}}</div>
            </div>
            <div class="warningInfoMainBoxItem">
              <div class="itemLeftBox">预警类型</div>
              <div class="itemRightBox">暴雨预警</div>
            </div>
            <div class="warningInfoMainBoxItem">
              <div class="itemLeftBox">预警等级</div>
              <div class="itemRightBox">
                <el-tag
                  size="small"
                  :color="getwaringLaver22(item.level).color"
                  @click="getMywarningArea(item)"
                >{{getwaringLaver22(item.level).text}}</el-tag>
              </div>
            </div>
            <div class="warningInfoMainBoxItem">
              <div class="itemLeftBox">降水量:</div>
              <div class="itemRightBox">{{item.rain}}㎜</div>
            </div>
            <div class="warningInfoMainBoxItem">
              <div class="itemLeftBox">影响面积</div>
              <div class="itemRightBox">{{item.mj}}平方千米</div>
            </div>
            <div class="warningInfoMainBoxItem">
              <div class="itemLeftBox">影响区域</div>
              <el-button type="primary" size="mini" @click="getMywarningArea(item)">查看</el-button>
            </div>
          </div>
        </div>
      </div>-->
      <!-- <div class="otherLaryerControllBox">
        <div class="layerChooseBoxTitle">
          <img src="../assets/Group_1321314869.png" alt />
          扩展图层
        </div>
        <div class="layerradioBox">
          <div class="testradiobox2" v-show="isShowlayerradioBox">
            <div>水系</div>
            <el-switch
              style="margin-left:10px"
              v-model="isSHowWarter"
              @change="extendCheckChange('水系')"
            ></el-switch>
          </div>
          <div class="testradiobox2" v-show="isShowlayerradioBox">
            <div>路网</div>
            <el-switch
              style="margin-left:10px"
              v-model="isShowRold"
              @change="extendCheckChange('路网')"
            ></el-switch>
          </div>
          <div class="testradiobox2" v-show="isShowlayerradioBox">
            <div>居民区</div>
            <el-switch
              style="margin-left:10px"
              v-model="isShowHouse"
              @change="extendCheckChange('居民区')"
            ></el-switch>
          </div>
          <div class="testradiobox2" v-show="isShowlayerradioBox">
            <div>水位</div>
            <el-switch
              style="margin-left:10px"
              v-model="isShowwater"
              @change="extendCheckChange('水位')"
            ></el-switch>
          </div>
          <div class="showRadioLayer" @click="isShowlayerradioBox=!isShowlayerradioBox">
            <i class="el-icon-caret-left" v-show="!isShowlayerradioBox"></i>
            <i class="el-icon-caret-right" v-show="isShowlayerradioBox"></i>
          </div>
        
        </div>
      </div>-->
      <div class="myLaryerControllBox">
        <!-- <div class="layerChooseBoxTitle">
          <img src="../assets/Group_1321314869.png" alt />
          图层检索
        </div>-->
        <div class="layerradioBox">
          <el-radio-group v-model="checkList2" @change="checkList2change" size="mini">
            <el-radio label="气象">气象</el-radio>
            <el-radio label="地质">地质</el-radio>
            <el-radio label="重点关注">重点关注</el-radio>
          </el-radio-group>
        </div>
        <div class="layerCHooseItemBox">
          <el-radio-group v-model="checkList" @change="showTypeChange">
            <div class="testRadio">
              <div class="testradiobox" v-for="item in checkListdata">
                <el-radio :label="item">{{item}}</el-radio>
              </div>
            </div>
          </el-radio-group>
        </div>
      </div>
    </div>
    <div class="layerControllBox" v-show="false">
      <!-- <div class="layerControllTitle">图层检索</div> -->
      <div class="layerSelectBox">
        <el-radio-group
          v-model="checkList2"
          @change="checkList2change"
          size="mini"
          fill="#32DCFE"
          class="checkList2Sec"
          text-color="#32DCFE"
        >
          <el-radio label="气象">气象</el-radio>
          <el-radio label="地质">地质</el-radio>
          <!-- <el-radio label="水位">水位</el-radio> -->
        </el-radio-group>
      </div>
      <div class="layerSelectBox mylayerSelectBox">
        <el-select
          v-model="checkList"
          @change="showTypeChange"
          placeholder="请选择"
          size="mini"
          class="checkListSec"
          v-show="checkList2!='水位'"
        >
          <el-option v-for="item in checkListdata" :label="item" :value="item"></el-option>
        </el-select>
        <div class="openBottomlaryerbtn" v-show="!isShowOtherLayer" @click="isShowOtherLayer=true">
          扩展图层
          <i class="el-icon-caret-bottom"></i>
        </div>
      </div>
      <div
        class="layerControllTitle"
        style="margin-top:15px"
        @click="isShowOtherLayer=false"
        v-if="isShowOtherLayer"
      >
        扩展图层
        <i class="el-icon-caret-top"></i>
      </div>
      <div class="layerSelectBox" v-if="isShowOtherLayer">
        <!-- <el-radio-group v-model="extendCheck" @change="extendCheckChange" size="mini" fill="#32DCFE" text-color="#32DCFE">
          <el-radio label="水系">水系</el-radio>
          <el-radio label="路网">路网</el-radio>
          <el-radio label="居民区">居民区</el-radio>
        </el-radio-group>-->
        <el-checkbox-group v-model="extendCheck" size="mini" @change="extendCheckChange">
          <el-checkbox label="水系"></el-checkbox>
          <el-checkbox label="路网"></el-checkbox>
          <el-checkbox label="居民区"></el-checkbox>
          <el-checkbox label="水位"></el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <div class="timeLineTopBox">
      <div class="timeTitleBox">预警推算</div>
      <div class="timeIconBox">
        <img src="../assets/暴雨_蓝.png" style="width:100%;height:100%" alt />
      </div>
      <div class="timemainBox">
        <div class="timemainBoxItem">
          <span style=" color: rgba(186, 253, 255, 1);">起报时间：</span>
          {{extrapolateData[0].datetime}}
        </div>
        <div class="timemainBoxItem">
          <span style=" color: rgba(186, 253, 255, 1);">预报时间：</span>
          {{extrapolateData[0].forcastTime}}
        </div>
      </div>
      <div class="timemainBox">
        <div class="timemainBoxItem">
          <span style=" color: rgba(186, 253, 255, 1);">降水量：</span>
          {{extrapolateData[0].rain}}
        </div>
        <div class="timemainBoxItem">
          <span style=" color: rgba(186, 253, 255, 1);">影响面积：</span>
          {{extrapolateData[0].mj}}
        </div>
      </div>
      <div class="timeAreaBtn" @click="getMywarningArea(extrapolateData[0])">影响区域</div>
    </div>
    <div class="timelineBox">
      <div class="playBtnBox" @click="palyHander">
        <img
          src="../assets/Group_1321314697.png"
          v-show="!this.isplaying"
          alt
          class="isplayingBtn"
          style
        />
        <img src="../assets/stop.png" v-show="this.isplaying" alt class="isplayingBtn" />
      </div>
      <div class="timeline">
        <el-slider
          style="zoom:0.7"
          v-model="timeLineData"
          show-stops
          :marks="marks"
          @change="showTimeCheng"
          :min="slidMindata"
          :max="slidMaxdata"
          size="mini"
        ></el-slider>
      </div>
    </div>
    <div class="listNewBox" v-show="isShowLengdhBox">
      <div class="optionSet" @click="isShowLengdhBox = false">隐藏图例</div>
      <div class="lendgenBox">
        <div class="lendgenBoxTitle">图例</div>
        <div class="showNumSwitch">
          <div>显示数值</div>
          <div>
            <el-switch v-model="isshownum" @change="isshownumchange"></el-switch>
          </div>
        </div>
        <div class="colorListBox">
          <div class="colorListBoxItem" v-for="item in ledgonList">
            <div class="colorBox" :style="{'backgroundColor':getrgb(item)}"></div>
            <div class="colorLable">{{item[0]}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="warningInfoBox" v-show="isShowwarningInfoBox">
      <div class="closeBoxImg" @click.stop="isShowwarningInfoBox=false">
        <img src="../assets/Frame_1714.png" style="width:100%;height:100%" alt />
      </div>
      <div class="warningInfoTitle">{{waringIfoList.headline}}</div>
      <div class="warningInfoMainBox">
        <div class="warningInfoMainBoxItem">
          <div class="itemLeftBox">开始时间</div>
          <div class="itemRightBox">{{waringIfoList.sendTime}}</div>
        </div>
        <div class="warningInfoMainBoxItem">
          <div class="itemLeftBox">结束时间</div>
          <div class="itemRightBox">{{waringIfoList.endTime}}</div>
        </div>
        <div class="warningInfoMainBoxItem">
          <div class="itemLeftBox">预警等级</div>
          <div class="itemRightBox">
            <el-tag
              size="small"
              :color="waringIfoList.leaveType"
              @click="openStrkHandell(waringIfoList)"
            >{{getwaringLaver(waringIfoList.leaveType)}}</el-tag>
          </div>
        </div>
        <div class="warningInfoMainBoxItem" style="height: auto;">
          <div class="itemLeftBox">预警详情</div>
          <div class="itemRightBox">{{waringIfoList.description}}</div>
        </div>
        <!-- <div class="warningInfoMainBoxItem">
          <div class="itemLeftBox">次生灾害</div>
          <div class="itemRightBox">{{waringIfoList.text}}</div>
        </div>
        <div class="warningInfoMainBoxItem">
          <div class="itemLeftBox">影响面积</div>
          <div class="itemRightBox">{{waringIfoList.areanum}}</div>
        </div>
        <div class="warningInfoMainBoxItem">
          <div class="itemLeftBox">影响区域</div>
          <div class="itemRightBox">{{waringIfoList.geocode}}</div>
        </div>-->
        <!-- <div class="warningInfoMainBoxItem">
          <div class="itemLeftBox">负责人</div>
          <div class="itemRightBox">{{waringIfoList.tel}}</div>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import WaterJson from "../map/511800.json";
import roldJson from "../map/rold.json";
import peoJson from "../map/peo.json";
import moment from "moment";
import md5 from "js-md5";
import waterPng from "../assets/water.png";
import movePng from "../assets/Frame_5.png";
import movePng2 from "../assets/Frame_6.png";
import movePng3 from "../assets/Frame_7.png";
import movePng4 from "../assets/Frame_8.png";
import waringIcon from "../assets/waringIcon.png";
// import moment from "moment";
// import WaterJson from "../map/511800.json";
// import roldJson from "../map/rold.json";
// import peoJson from "../map/peo.json";
import vueSeamlessScroll from "vue-seamless-scroll";
import macarons from "../map/macarons.json";
import shimian from "../map/shimian.json";
import yingjing from "../map/lj.json";
import wind1 from "../assets/wind/wind1.png";
import wind2 from "../assets/wind/wind2.png";
import wind3 from "../assets/wind/wind3.png";
import wind4 from "../assets/wind/wind4.png";
import wind5 from "../assets/wind/wind5.png";
import wind6 from "../assets/wind/wind6.png";
import wind7 from "../assets/wind/wind7.png";
import wind8 from "../assets/wind/wind8.png";
import wind9 from "../assets/wind/wind9.png";
import wind10 from "../assets/wind/wind10.png";
import wind11 from "../assets/wind/wind11.png";
import wind12 from "../assets/wind/wind12.png";
import Videojs from "video.js";
import china from "../map/china.json";
import jsCookie from "js-cookie";
import { unzip } from "../map/zip.js";
import "video.js/dist/video-js.css";
import "videojs-flvjs-es6";
import "videojs-flash";
import { MapCreate, legendColor } from "../map/mapImport.js";
export default {
  data() {
    return {
      isShowdaizailegon:false,
      dizaiwarningList:[],
      getimgTime:"",
      CloundDataGroup: null,
      warningcountData: [{}, {}, {}, {}],
      areaNameLayer: null,
      warningTime: [
        moment()
          .subtract(1, "d")
          .format("YYYY-MM-DD HH:00:00"),
        moment().format("YYYY-MM-DD HH:00:00")
      ],
      warningTextStr: "",
      isShowLengdhBox: false,
      earthMakerLayer: null,
      echartsLayer: null,
      tranLeft: 0,
      tranTop: 0,
      isShowEchartsBox: false,
      EarthquakeDataList: [
        {
          id: 3305,
          rank: "3.6",
          earthquakeTime: 1721281690000,
          lat: 44.35,
          lon: 83.34,
          deepth: 16,
          place: "新疆博尔塔拉州精河县",
          placeUrl: "https://news.ceic.ac.cn/CD20240718134811.html"
        }
      ],
      isShowPlaceWaring: true,
      isShowEarthquake: true,
      isShowWartherWaring: true,
      isShowlayerradioBox: false,
      classOption: {
        step: 0.2,
        singleWidth: 0,
        direction: 1
      },
      isSHowWarter: false,
      isShowRold: false,
      isShowHouse: false,
      isShowwater: false,
      waringListplace: [],
      isShowWarningLayer: false,
      extrapolateData: [{}],
      showoptSetBox: false,
      videoCHooseItem: "视频监测站1",
      isShowOtherLayer: false,
      waringList: [],
      waringList2: [
        {
          headline: 11111111111
        }
      ],
      isshownum: false,
      tilePixelLayer: null,
      chooseGridData: null,
      ledgonList: legendColor["rain"],
      gridDataList: [],
      isShowWindLayer: false,
      userareaCode: "511800",
      checkList2: "气象",
      isplaying: false,
      slidMindata: 0,
      slidMaxdata: 23,
      timeLineData: 0,
      marks: {
        0: "0°C",
        8: "8°C",
        37: "37°C",
        50: {
          style: {
            color: "#1989FA"
          },
          label: this.$createElement("strong", "50%")
        }
      },
      waringIfoList: {
        headline: "石棉发布暴雨红色预警",
        startTime: "2024-03-28 12:00:00",
        endTime: "2024-03-28 16:00:00",
        level: "红色预警",
        text: "可能造成相关区域地质灾害（滑坡）",
        areanum: "242平方千米",
        area: "美罗乡,迎政乡,宰羊乡,丰乐乡",
        tel: "182xxxxxxxx 王xx",
        leaveType: "red"
      },
      isSHowNum: false,
      typeCHoose: 3,

      showtype: "选项1",
      value: [30, 60],

      sldPlayTimeer: null,
      checkListdata: ["雨量", "温度", "云图", "雷达"],
      checkList: "雨量",
      ledgonList: legendColor["rain"],
      weatherdata: {
        dis: 0.0001907141839999417,
        CityName: "雅安",
        cid: "CN101271701",
        cloud: 10,
        cond_code: 150,
        cond_txt: "晴",
        fl: -1,
        hum: 98,
        loc: 1703628240000,
        pcpn: 0,
        pres: 952,
        tmp: 4,
        vis: 2,
        wind_deg: 46,
        wind_dir: "东北风",
        wind_sc: "1",
        wind_spd: 5,
        tmp_max: 13,
        tmp_min: 3
      },
      extendCheck: [],
      waterLayer: null,
      roldLayer: null,
      peoLayer: null,
      optData: 100,
      isShowwarningInfoBox: false,
      imgLayer: null,
      windspeedLayer: null,
      sctimer: null,
      sctimer2: null
    };
  },
  mounted() {
    // dizaiwarningList
    for (let i = 1; i < 10; i++) {
      console.log(moment()
            .subtract(i, "d")
            .format("YYMMDD"));
            this.dizaiwarningList.push({time:moment()
            .subtract(i, "d")
            .format("YYMMDD")})
      
    }
console.log(this.dizaiwarningList);
    this.map = new MapCreate();
    //   this.map.init();
    this.map.init("map");
    let t = this;
    // this.map.map.on("click", e => {
    //   // console.log(e);
    //   //  e.preventDefault();
    //   t.showEchartsBox(e);
    // });
    let layerJson = china;
    let myuserinfo = JSON.parse(jsCookie.get("areainfo"));
    console.log(myuserinfo);
    this.userareaCode = myuserinfo.areaCode;
    let style = {
      color: "#FCB042", //线颜色
      weight: 5, //线粗细
      opacity: 1, //透明度
      opacity: 1,
      fillColor: "#2F5B00", //区域填充颜色
      fillOpacity: 0 //区域填充颜色的透明
    };
    let areaNameList = [];
    if (this.userareaCode == "511800") {
      let myAreaLayer = L.geoJSON(china.features, {
        style: style,
        onEachFeature: e => {
          // console.log(2212121);
          let print = t.getPolygon(e.geometry.coordinates[0][0]);
          console.log(print);
          console.log(e.properties.name);
          let myIcon = L.divIcon({
            html: `<div class="myareaNameBox" style="font-size: 12px;width:100px;text-align:center;  font-weight: 800;
                  ">${e.properties.name}</div>`,
            className: "my-div-icon",
            iconSize: [50, 50],
            bgPos: [-50, -50]
          });
          let mymarker = L.marker(print, { icon: myIcon });
          areaNameList.push(mymarker);
        }
      }).addTo(this.map.map);
      this.areaNameLayer = L.layerGroup(areaNameList).addTo(this.map.map);
      L.mask(china.features, {
        fillOpacity: 0.5,
        fillColor: "#04777A",
        color: "#04777A",
        opacity: 0,
        fitBounds: false,
        restrictBounds: false
      }).addTo(this.map.map);
      this.map.map.flyToBounds(myAreaLayer.getBounds());
    } else {
      china.features.map(item => {
        console.log(item);
        if (item.properties.adcode == this.userareaCode) {
          layerJson = item;
        }
      });
      let myAreaLayer = L.geoJSON(layerJson, { style: style }).addTo(
        this.map.map
      );
      L.mask(layerJson, {
        fillOpacity: 0.5,
        fillColor: "#04777A",
        color: "#04777A",
        opacity: 0,
        fitBounds: false,
        restrictBounds: false
      }).addTo(this.map.map);
      this.map.map.flyToBounds(myAreaLayer.getBounds());
    }
    this.map.map.on("zoomend", () => {
      //console.log(parseInt(20 / this.map.map.getZoom()));
      // //console.log(map.getZoom());
      if (this.isShowWindLayer == true) {
        t.drawMakerTomap(
          this.chooseGridData.windS,
          this.chooseGridData.windD,
          parseInt(20 / this.map.map.getZoom()),
          this.chooseGridData
        );
      }
    });
    this.getEchartsData();
    this.getlineMarker(moment(new Date()).format("YYYY-MM-DD HH:mm:ss"));
    this.$nextTick(() => {
      // this.autoSroll();
      // this.autoSroll3("scroll_in2");
    });

    // this.palyvideo(
    //   "https://sjtq.tianqi.cn/live/5107_7b9d4717b2f011ebb04e6c92bf487b62.m3u8"
    // );
  },
  created() {
    let myuserinfo = JSON.parse(jsCookie.get("areainfo"));
    console.log(myuserinfo.areaCode);
    this.userareaCode = myuserinfo.areaCode;
    this.getweatherData();
    this.getGridData("rain");
    this.getextrapolateData();
    this.getPlaceDataList();
    this.getWaringData();
    this.getEarthquakeData();
    this.getWarningText();
  },
  destroyed() {
    console.log("beforeDestory");
    this.map.map.remove();
    clearInterval(this.sctimer);
    clearInterval(this.sctimer2);
  },
  components: {
    vueSeamlessScroll
  },
  methods: {
    getEchartsData() {
      let code = 5118;
      if (this.userareaCode == 511800) {
        code = 5118;
      } else {
        code = this.userareaCode;
      }
      this.$axios({
        method: "post",
        url: `https://www.moodsci.com/SWDataservice/interface/v1/api?interfaceId=getYaanWarnCount&starttime=${moment()
          .subtract(1, "d")
          .format("YYYY-MM-DD HH:00:00")}&adcode=${code}`
      })
        .then(res => {
          console.log(res.data.dataList);
          let mydata = [];

          res.data.dataList.map(item => {
            //console.log(item);
            mydata.push({ value: item.cout, name: item.type });
          });
          console.log(mydata);
          this.warningcountData = mydata;
          // var chartDom = document.getElementById("roundEchartBox");
          // echarts.registerTheme("macarons", macarons);
          // var myChart = echarts.init(chartDom, "macarons");
          // let option = {
          //   tooltip: {
          //     trigger: "item"
          //   },
          //   legend: {
          //     orient: "vertical",
          //     x: "right", //可设定图例在左、右、居中
          //     y: "center",
          //     textStyle: {
          //       color: "white" // 图例文字颜色
          //     },
          //     data: mydata,
          //     formatter: function(name) {
          //       //通过name获取到数组对象中的单个对象
          //       let singleData = mydata.filter(function(item) {
          //         return item.name == name;
          //       });
          //       return name + " | " + singleData[0].value + "次";
          //       //console.log(name);
          //     }
          //   },
          //   series: [
          //     {
          //       center: ["35%", "50%"],
          //       name: "",
          //       type: "pie",
          //       radius: ["50%", "90%"],
          //       avoidLabelOverlap: false,
          //       itemStyle: {
          //         borderRadius: 10,
          //         borderColor: "#fff",
          //         borderWidth: 1,
          //         normal: {
          //           color: function(colors) {
          //             var colorList = ["blue", "yellow", "orange", "red"];
          //             return colorList[colors.dataIndex];
          //           }
          //         }
          //       },
          //       label: {
          //         show: false,
          //         position: "center"
          //       },
          //       emphasis: {
          //         label: {
          //           show: true,
          //           fontSize: 40,
          //           fontWeight: "bold"
          //         }
          //       },
          //       labelLine: {
          //         show: false
          //       },
          //       data: mydata
          //     }
          //   ]
          // };

          // option && myChart.setOption(option);
        })
        .catch(() => {
          console.log(21212);
        });
    },
    getPolygon(pList) {
      var area = 0;
      var x = 0;
      var y = 0;
      for (var i = 1; i <= pList.length; i++) {
        var lat = pList[i % pList.length][0];
        var lng = pList[i % pList.length][1];
        var nextLat = pList[i - 1][0];
        var nextLng = pList[i - 1][1];
        var temp = (lat * nextLng - lng * nextLat) / 2;
        area += temp;
        x += (temp * (lat + nextLat)) / 3;
        y += (temp * (lng + nextLng)) / 3;
      }
      x = x / area;
      y = y / area;
      return [y, x];
    },
    getWarningText() {
      this.$axios({
        method: "post",
        url: `
http://120.79.183.250:3099/warn/warn`
      }).then(res => {
        console.log(res.data.datas);
        this.warningTextStr = res.data.datas;
      });
    },
    handleClick(e) {
      console.log(e.target.dataset.obj);
      let mydataObj = JSON.parse(e.target.dataset.obj);
      console.log(mydataObj);
      this.getMywarningArea(mydataObj);
      // if (e.target.dataset.obj != undefined) {
      //   const obj = JSON.parse(e.target.dataset.obj);
      //   console.log(obj);
      //   this.getextrapolateData2(obj.time, obj.time2);
      //   // this.placeshowToMap(obj.time);
      // }
      // console.log(e.target.dataset.obj);
    },
    handleClick2(e) {
      if (e.target.dataset.obj != undefined) {
        const obj = JSON.parse(e.target.dataset.obj);
        // console.log(obj);
        this.placeshowToMap(obj.time);
      }
      // console.log(e.target.dataset.obj);
    },
     handleClick3(e) {
      if (e.target.dataset.obj != undefined) {
        const obj = JSON.parse(e.target.dataset.obj);
        console.log(111);
        console.log(obj);
        this.showDizaiTomao(obj.time)
        // this.placeshowToMap(obj.time);
      }
      // console.log(e.target.dataset.obj);
    },
    showDizaiTomao(time){
            if (this.imgLayer != null) {
          this.map.map.removeLayer(this.imgLayer);
          this.imgLayer = null;
        }
          this.isShowdaizailegon=false
      let t =this
        if (this.imgLayer != null) {
          this.map.map.removeLayer(this.imgLayer);
          this.imgLayer = null;
        }
            let imageBounds = [
          [25.4, 96.5],
          [35.9, 109.4]
        ];
        
        // 将图片作为自定义图层加载到地图上（类似于Marker）
        this.imgLayer = L.imageOverlay(
          `https://www.moodsci.com/image/dizaipic/${time}/${time}20.png`,
          imageBounds,
          { opacity: 1, zIndex: 999 }
        ).addTo(this.map.map);
         this.imgLayer.on("load",(e)=>{
          t.$message({
          message: '加载成功',
          type: 'success'
        });
         })
          this.imgLayer.on("error",(e)=>{
          t.$message({
          message: '加载失败',
          type: 'warning'
        });
         })
        //  setTimeout(() => {
        //    if (this.imgLayer != null) {
        //   this.map.map.removeLayer(this.imgLayer);
        //   this.imgLayer = null;
        // }
        //   this.isShowdaizailegon=false
        //  }, 2000);
        this.map.map.fitBounds(imageBounds);
        this.isShowdaizailegon=true
    },
    getwaringLaver(data) {
      // console.log(data);
      if (data == "red") {
        return "红色预警";
      } else if (data == "orange") {
        return "橙色预警";
      } else if (data == "yellow") {
        return "黄色预警";
      }
    },
    getwaringLaver22(data) {
      // console.log(data);
      if (data == "3") {
        return {
          text: "红色预警",
          color: "red"
        };
      } else if (data == "2") {
        return {
          text: "橙色预警",
          color: "orange"
        };
      } else if (data == "1") {
        return {
          text: "黄色预警",
          color: "yellow"
        };
      }
    },
    showEarthquakePrint(data) {
      if (this.earthMakerLayer) {
        this.map.map.removeLayer(this.earthMakerLayer);
        this.earthMakerLayer = null;
      }
             if (this.imgLayer != null) {
          this.map.map.removeLayer(this.imgLayer);
          this.imgLayer = null;
        }
          this.isShowdaizailegon=false
       if (this.imgLayer != null) {
          this.map.map.removeLayer(this.imgLayer);
          this.imgLayer = null;
        }
      console.log(data);
      let mymakerdata = L.circleMarker([data.lat, data.lon], {
        radius: 10,
        opacity: 1,
        color: "white",
        fillColor: "yellow",
        fillOpacity: 1,
        className: "EarthquakeMaker"
      })
        .bindPopup(
          `
            <p>地点：${data.place}</p>
            <p>深度：${data.deepth}千米</p>
            <p>震级：${data.rank}</p>
            <p>时间：${data.earthquakeTime}</p>

            `
        )
        .openPopup();
      this.map.map.flyTo([data.lat, data.lon], 8);
      let popup = L.popup({
        autoClose: true,
        autoPanPaddingBottomRight: L.point(600, 0)
      })
        .setLatLng([data.lat, data.lon])
        .setContent(
          `
              <p>地点：${data.place}</p>
              <p>深度：${data.deepth}千米</p>
              <p>震级：${data.rank}</p>
              <p>时间：${data.earthquakeTime}</p>
              
              `
        )
        .openOn(this.map.map);
      this.earthMakerLayer = mymakerdata.addTo(this.map.map);
    },
    getDangerDataList() {
      let myUrl =
        "https://www.moodsci.com/SWDataservice/interface/v1/api?interfaceId=getYaanHiddenStation";
      if (this.checkList == "地灾隐患点") {
        myUrl =
          "https://www.moodsci.com/SWDataservice/interface/v1/api?interfaceId=getYaanHiddenStation";
      } else {
        myUrl =
          "https://www.moodsci.com/SWDataservice/interface/v1/api?interfaceId=getYaanZdqy";
      }
      this.$axios({
        method: "post",
        url: myUrl
      }).then(res => {
        let myWarningListData = res.data.dataList;
        let markerList = [];
        let moveIcon = L.icon({
          iconUrl: waringIcon, //icon阴影图片路径

          iconSize: [25, 25] // size of the icon
        });
        console.log(myWarningListData);
        let t = this;
        myWarningListData.map(item => {
          // console.log(item);
          let myMarker = L.marker([item.Lat, item.Lon], { icon: moveIcon });
          myMarker.on("click", e => {
            // console.log(e);
            // console.log(e.latlng, "雨量");
            // t.tranLeft = e.containerPoint.x + "px";
            // t.tranTop = e.containerPoint.y - 300 + "px";
            // t.isShowEchartsBox = true;
            t.setEchartsOption(e.latlng, "雨量");
          });
          // .bindPopup(
          //   `
          //      <div class="warningInfoTitle2">站点数据</div>
          //      <p>平均温度：${item.TEM == 999999 ? "无监测" : item.TEM + "℃"}</p>
          //     <p>一小时降水量：${
          //       item.PRE_1h == 999999 ? "无监测" : item.PRE_1h + "㎜"
          //     }</p>
          //      <p>风速：${
          //        item.WIN_S_Avg_2mi == 999999
          //          ? "无监测"
          //          : item.WIN_S_Avg_2mi + "米每秒"
          //      }</p>
          //       <p>风向：${
          //         item.WIN_D_Avg_2mi == 999999
          //           ? "无监测"
          //           : item.WIN_D_Avg_2mi + "°"
          //       }</p>
          //   `
          // )
          // .openPopup();

          markerList.push(myMarker);
        });
        this.movePlaceLayer = L.layerGroup(markerList).addTo(this.map.map);
      });
    },
    showEchartsBox(e) {
      // console.log(e);
      // console.log(e.layerPoint);
      // console.log(e.latlng);
      // this.tranLeft = e.containerPoint.x + "px";
      // this.tranTop = e.containerPoint.y - 300 + "px";
      // this.isShowEchartsBox = true;
      console.log(this.chooseGridData);
      if (
        e.latlng.lat < this.chooseGridData.top &&
        e.latlng.lat > this.chooseGridData.bottom &&
        e.latlng.lng > this.chooseGridData.left &&
        e.latlng.lng < this.chooseGridData.right
      ) {
        this.setEchartsOption(e.latlng, this.checkList);
      } else {
        this.$message("超出范围");
      }

      // this.$refs.echartsbox.
    },
    setEchartsOption(data, type) {
      if (this.echartsLayer != null) {
        this.echartsLayer.dispose();
      }
      let elementType = "rain";
      let textType = type;
      if (type == "雨量") {
        elementType = "rain";
      } else if (this.checkList == "温度") {
        elementType = "tem";
      } else {
        textType = "雨量";
      }
      let formData = new FormData();
      formData.append(
        "para",
        `{"dateTime":"${moment()
          .subtract(1, "h")
          .format(
            "YYYY-MM-DD HH:00:00"
          )}","areaCode":"null","element":"${elementType}","lat":"${
          data.lat
        }","lon":"${data.lng}","type":"null"}`
      );
      const loading = this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$axios({
        method: "post",
        url: `
       http://120.79.183.250:3099/grid/getGrid2Point`,
        data: formData
      })
        .then(res => {
          // console.log();

          let timeList = [];
          let dataList = [];
          let sumDataList = [];
          let sumList = 0;
          res.data.datas.map(item => {
            timeList.push(item.time);
            dataList.push(item.value.toFixed(2));
            sumList = sumList +Number(item.value) ;
            sumDataList.push(sumList.toFixed(2));
          });
          console.log();
          //  let obj = JSON.parse(macarons)
          let popup = L.popup({
            minWidth: 616,
            autoClose: true,
            className: "mynewPopBox",
            // autoPanPaddingTopLeft: L.point(400, 0),
            autoPanPaddingBottomRight: L.point(600, 0)
          })
            .setLatLng([data.lat, data.lng])
            .setContent(
              `<div style="width:616px;height:223px" id="myechartsBox"></div>`
            )
            .openOn(this.map.map);
          let t = this;

          echarts.registerTheme("macarons", macarons);
          this.echartsLayer = echarts.init(
            document.querySelector("#myechartsBox"),
            "macarons"
          );
          let dataServeList = [
            {
              data: dataList,
              type: "line",
              name: "时次降水",
              itemStyle: {
                normal: {
                  color: "rgba(36, 124, 255, 0.8)"
                }
              },
              lineStyle: {
                normal: {
                  color: "rgba(36, 124, 255, 0.8)"
                }
              },
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(36, 124, 255, 0.8)"
                      // 0% 处的颜色
                    },
                    {
                      offset: 0.5,
                      color: "rgba(36, 124, 255, 0.8)"
                      // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(64, 255, 255, 0.62)"
                      // 0% 处的颜色
                    }
                  ]
                }
              }
            },
            {
              name: "累积降水",
              type: "line",
              stack: "Total",
              data: sumDataList,
              itemStyle: {
                normal: {
                  color: "rgba(255, 229, 1, 0.8)"
                }
              },
              lineStyle: {
                normal: {
                  color: "rgba(255, 229, 1, 0.8)"
                }
              },
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(255, 229, 1, 0.8)"
                      // 0% 处的颜色
                    },
                    {
                      offset: 0.5,
                      color: "rgba(255, 229, 1, 0.8)"
                      // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(64, 255, 255, 0.62)"
                      // 0% 处的颜色
                    }
                  ]
                }
              }
            }
          ];
          let titleText = `[${data.lng.toFixed(2)}，${data.lat.toFixed(
            2
          )}]点位降雨预报统计图`;
          let axisName = "降水(㎜)";
          if (textType != "雨量") {
            dataServeList = [
              {
                data: dataList,
                type: "line",
                name: "温度",
                areaStyle: {}
              }
            ];
            axisName = "温度(℃)";
            titleText = `[${data.lng.toFixed(2)}，${data.lat.toFixed(
              2
            )}]点位温度预报统计图`;
          }
          let option = {
            backgroundColor: "rgba(255,255,255,0)",
            toolbox: {
              show: true,
              right: 30,
              feature: {
                saveAsImage: {},
                /* line是折线图，bar是柱形图*/
                magicType: { show: true, type: ["line", "bar"] }
              }
            },

            title: {
              x: "center",
              y: "bottom",
              text: titleText,
              textStyle: {
                //主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"}
                fontFamily: "Arial, Verdana, sans...",
                fontSize: 12,
                fontStyle: "normal",
                fontWeight: "normal",
                color: "white"
              }
            },
            legend: {
              data: [
                {
                  name: "时次降水",
                  textStyle: {
                    color: "white" // 图例文字颜色
                  }
                },
                {
                  name: "累积降水",
                  textStyle: {
                    color: "white" // 图例文字颜色
                  }
                },
                {
                  name: "温度",
                  textStyle: {
                    color: "white" // 图例文字颜色
                  }
                }
              ]
            },
            xAxis: {
              type: "category",
              data: timeList,
              name: "时间"
            },
            yAxis: {
              type: "value",
              name: axisName
            },
            tooltip: {
              trigger: "axis", //坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用
              // formatter: function(params) {
              //   params.map(item => {
              //     item.data =Number(item.data).toFixed(2);
              //     return item;
              //   });
              //   console.log(params);
              //   return params;
              // },

              axisPointer: {
                // 坐标轴指示器，坐标轴触发有效
                type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
              }
            },

            series: dataServeList
          };
          this.echartsLayer.setOption(option);
          loading.close();
        })
        .catch(() => {
          loading.close();
        });
    },
    getEarthquakeData() {
      let formData = new FormData();

      formData.append(
        "para",
        `{"starttime":"2024-07-01 15:00:00","endtime":"null"}`
      );
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `http://120.79.183.250:3099/data/earthquake`,
        data: formData
      }).then(res => {
        console.log(res.data);
        this.EarthquakeDataList = res.data.slice(0, 100);
        // //console.log(res.data.datas[0]);
      });
    },
    autoSroll() {
      // flag 为true时停止滚动
      let myref = this.$refs.myplaceWaring;
      var flag = false;
      // 定时器
      let t = this;
      function roll() {
        var h = -1;
        t.sctimer = setInterval(function() {
          flag = true;
          //获取当前滚动条高度
          var current = myref.scrollTop;
          if (current == h) {
            //滚动到底端,返回顶端
            h = 0;
            myref.scrollTop = h + 1;
          } else {
            //以25ms/3.5px的速度滚动
            h = current;
            myref.scrollTop = h + 1;
          }
          console.log(h);
        }, 50);
      }
      // setTimeout(function() {
      //滚动区域内单击鼠标 滚动暂停 再次点击鼠标 继续滚动
      myref.onclick = () => {
        // ////console.log("点击了", timer, flag);
        if (flag) {
          flag = false;
          clearInterval(t.sctimer);
        } else {
          roll();
        }
      };
      roll();
      // }, 2000);
    },
    autoSroll3(Id) {
      // flag 为true时停止滚动
      var flag = false;
      // 定时器
      let t = this;
      function roll() {
        var h = -1;
        t.sctimer2 = setInterval(function() {
          flag = true;
          //获取当前滚动条高度
          var current = document.getElementById(Id).scrollTop;
          if (current == h) {
            //滚动到底端,返回顶端
            h = 0;
            document.getElementById(Id).scrollTop = h + 1;
          } else {
            //以25ms/3.5px的速度滚动
            h = current;
            document.getElementById(Id).scrollTop = h + 1;
          }
        }, 50);
      }
      // setTimeout(function() {
      //滚动区域内单击鼠标 滚动暂停 再次点击鼠标 继续滚动
      document.getElementById(Id).onclick = () => {
        // ////console.log("点击了", timer, flag);
        if (flag) {
          flag = false;
          clearInterval(t.sctimer2);
        } else {
          roll();
        }
      };
      roll();
      // }, 2000);
    },
    placeshowToMap(time) {
      console.log(time);
      this.isShowWindLayer = false;
      this.isShowWarningLayer = false;
      if (this.chooseTimeImgName == time) {
        // if (this.imgLayer != null) {
        //   this.map.map.removeLayer(this.imgLayer);
        //   this.imgLayer = null;
        // }
        if (this.CloundDataGroup != null) {
          this.map.map.removeLayer(this.CloundDataGroup);
          this.CloundDataGroup = null;
        }
        this.chooseTimeImgName = "";
        this.changeMapGrid();
      } else {
        if (this.tilePixelLayer) {
          this.map.map.removeLayer(this.tilePixelLayer);
          this.tilePixelLayer = null;
        }
        if (this.windspeedLayer) {
          this.map.map.removeLayer(this.windspeedLayer);
          this.windspeedLayer = null;
        }
        if (this.CloundDataGroup != null) {
          this.map.map.removeLayer(this.CloundDataGroup);
          this.CloundDataGroup = null;
        }
        this.chooseTimeImgName = time;
        let imageBounds = [
          [25.4, 96.5],
          [35.9, 109.4]
        ];

        // 将图片作为自定义图层加载到地图上（类似于Marker）
        this.imgLayer = L.imageOverlay(
          `https://mh.icdnrsc.net/Admin_Models/DZYJ/DZimg/DZZH${time}20.gif`,
          imageBounds,
          { opacity: 1, zIndex: 999 }
        ).addTo(this.map.map);
        this.map.map.fitBounds(imageBounds);
      }

      // if (this.placeshowLayer != null) {
      //   this.placeshowLayer.removeFrom(this.map.map);
      //   this.placeshowLayer = null;
      // }
      // let moveIcon = L.icon({
      //   iconUrl: movePng, //icon阴影图片路径

      //   iconSize: [25, 25] // size of the icon
      // });
      // this.placeshowLayer = L.marker([data1, data2], { icon: moveIcon }).addTo(
      //   this.map.map
      // );
      //  L.layerGroup(markerList)
    },
    getPlaceDataList2() {
      for (let index = 1; index < 8; index++) {
        this.waringListplace.push({
          text: `${moment()
            .subtract(index, "d")
            .format("YYMMDD")}地灾预警查看`,
          time: moment()
            .subtract(index, "d")
            .format("YYYY-MM-DD 08:00:00"),
          time2: moment()
            .subtract(index, "d")
            .format("YYYY-MM-DD 20:00:00")
        });
        console.log(
          moment()
            .subtract(index, "d")
            .format("YYYY-MM-DD")
        );
      }
    },
    getPlaceDataList() {
      let formData = new FormData();

      formData.append(
        "datetime",
        moment()
          .subtract(15, "d")
          .format("YYYY-MM-DD 08:00:00")
      );
      formData.append("datetime1", moment().format("YYYY-MM-DD 08:00:00"));
      formData.append("areaCode", `null`);
      formData.append("element", `rain`);
      formData.append("forcastEndTime", `null`);
      formData.append("forcastStartTime", `null`);
      formData.append("type", `null`);
      this.$axios({
        method: "post",
        url: `http://120.79.183.250:3099/warn/getForcastWarn`,
        data: formData
      }).then(res => {
        console.log(res.data.datas);
        this.waringListplace = res.data.datas;
        // if (res.data.datas.length == 0) {
        //   this.extrapolateData = [];
        // } else {
        //   this.extrapolateData = [res.data.datas[0]];
        // }

        // //console.log(res.data.datas[0]);
      });
      // for (let index = 1; index < 8; index++) {
      //   this.waringListplace.push({
      //     text: `起报${moment()
      //       .subtract(index, "d")
      //       .format("YYYY-MM-DD 10")}时，预报${moment()
      //       .subtract(index, "d")
      //       .format("YYYY-MM-DD 20")}时`,
      //     time: moment()
      //       .subtract(index, "d")
      //       .format("YYYYMMDD")
      //   });
      //   console.log(
      //     moment()
      //       .subtract(index, "d")
      //       .format("YYYY-MM-DD")
      //   );
      // }
    },
    getMywarningArea(data) {
           if (this.imgLayer != null) {
          this.map.map.removeLayer(this.imgLayer);
          this.imgLayer = null;
        }
          this.isShowdaizailegon=false
      this.isShowWindLayer = false;
       if (this.imgLayer != null) {
          this.map.map.removeLayer(this.imgLayer);
          this.imgLayer = null;
        }
      if (this.isShowWarningLayer == false) {
        if (this.CloundDataGroup != null) {
          this.map.map.removeLayer(this.CloundDataGroup);
          this.CloundDataGroup = null;
        }
        if (this.windspeedLayer) {
          this.map.map.removeLayer(this.windspeedLayer);
          this.windspeedLayer = null;
        }
        if (this.tilePixelLayer) {
          this.map.map.removeLayer(this.tilePixelLayer);
          this.tilePixelLayer = null;
        }
        // console.log(112121);
        if (this.isplaying) {
          this.palyHander();
        }
        this.isShowWarningLayer = !this.isShowWarningLayer;
        let ledcolorList = JSON.parse(JSON.stringify(legendColor["warning"]));
        ledcolorList.map((item, index) => {
          ////console.log(index);
          if (index == 0) {
            return (item[1][3] = 0);
          } else {
            return (item[1][3] = this.optData / 400);
          }
        });
        let t = this;
        this.tilePixelLayer = L.tilePixelLayer({
          newData: data.datas.split(","),
          data: data,
          gradient: ledcolorList
          // clickEvt: function(e, gridValue) {
          //   console.log(e, gridValue);
          //   let popup = L.popup()
          //     .setLatLng([e.latlng.lat, e.latlng.lng])
          //     .setContent(`<div>${t.checkList}值:${gridValue}</div>`)
          //     .openOn(t.map.map);
          // }
        });
        // this.map.map.on("layeradd", () => {
        //   console.log("layeradd");
        //   this.map.map.removeLayer(oldTitle);
        // });
        this.map.map.addLayer(this.tilePixelLayer);
      } else {
        if (this.tilePixelLayer) {
          this.map.map.removeLayer(this.tilePixelLayer);
          this.tilePixelLayer = null;
        }
        this.isShowWarningLayer = !this.isShowWarningLayer;
        this.changeMapGrid();
      }
    },
    getextrapolateData() {
      let formData = new FormData();

      formData.append("datetime", `null`);
      formData.append("datetime1", `null`);
      formData.append("areaCode", `null`);
      formData.append("element", `rain`);
      formData.append("forcastEndTime", `null`);
      formData.append("forcastStartTime", `null`);
      formData.append("type", `null`);
      this.$axios({
        method: "post",
        url: `http://120.79.183.250:3099/warn/getForcastWarn`,
        data: formData
      }).then(res => {
        console.log(res.data.datas);
        if (res.data.datas.length == 0) {
          this.extrapolateData = [];
        } else {
          this.extrapolateData = [res.data.datas[0]];
        }

        // //console.log(res.data.datas[0]);
      });
    },
    getextrapolateData2(datetime, datetime1) {
      let formData = new FormData();

      formData.append("datetime", datetime);
      formData.append("datetime1", datetime1);
      formData.append("areaCode", `null`);
      formData.append("element", `rain`);
      formData.append("forcastEndTime", `null`);
      formData.append("forcastStartTime", `null`);
      formData.append("type", `null`);
      this.$axios({
        method: "post",
        url: `http://120.79.183.250:3099/warn/getForcastWarn`,
        data: formData
      }).then(res => {
        console.log(res.data.datas);
        if (res.data.datas.length == 0) {
          this.extrapolateData = [];
        } else {
          this.extrapolateData = [res.data.datas[0]];
          this.getMywarningArea(this.extrapolateData[0]);
        }

        // //console.log(res.data.datas[0]);
      });
    },
    changeoptDataHandel() {
      //console.log(this.optData);
      // ////console.log(this.optData / 100);

      // if (this.checkList == "雨量") {
      //   this.getGridData("pre");
      // } else if (this.checkList == "温度") {
      //   this.getGridData("tem");
      // } else if (this.checkList == "大风") {
      //   this.getGridData("wind_s");
      // }
      if (this.tilePixelLayer) {
        this.map.map.removeLayer(this.tilePixelLayer);
        this.tilePixelLayer = null;
      }
      if (this.windspeedLayer) {
        this.map.map.removeLayer(this.windspeedLayer);
        this.windspeedLayer = null;
      }
      this.showoptSetBox = false;
      let type = "rain";
      if (this.checkList == "雨量") {
        type = "rain";
      } else if (this.checkList == "温度") {
        type = "tem";
        // this.getGridData("tem");
      } else if (this.checkList == "大风") {
        type = "wind";
        // this.getGridData("wind_s");
      } else if (this.checkList == "雷达") {
        type = "radar";
        // this.getGridData("wind_s");
      }

      let ledcolorList = JSON.parse(JSON.stringify(legendColor[type]));
      ledcolorList.map((item, index) => {
        ////console.log(index);
        if (index == 0) {
          return (item[1][3] = 0);
        } else {
          return (item[1][3] = this.optData / 400);
        }
      });
      //console.log(ledcolorList);
      //console.log(type);
      if (type != "wind") {
        let dataList = [];
        if (type == "radar") {
          dataList = this.gridDataList[this.timeLineData].datas.map(item => {
            return Number(item);
          });
        } else {
          dataList = this.gridDataList[this.timeLineData].datas
            .split(",")
            .map(item => {
              return Number(item);
            });
        }
        let t = this;
        this.tilePixelLayer = L.tilePixelLayer({
          newData: dataList,
          data: this.gridDataList[this.timeLineData],
          gradient: ledcolorList
          // clickEvt: function(e, gridValue) {
          //   console.log(e, gridValue);
          //   let popup = L.popup()
          //     .setLatLng([e.latlng.lat, e.latlng.lng])
          //     .setContent(`<div>${t.checkList}值:${gridValue}</div>`)
          //     .openOn(t.map.map);
          // }
        });

        this.map.map.addLayer(this.tilePixelLayer);
      } else {
        this.drawMakerTomap(
          this.gridDataList[this.timeLineData].windS,
          this.gridDataList[this.timeLineData].windD,
          parseInt(20 / this.map.map.getZoom()),
          this.gridDataList[this.timeLineData]
        );
        let ledcolorList = JSON.parse(JSON.stringify(legendColor["windmy"]));

        ledcolorList.map((item, index) => {
          ////console.log(index);
          if (index == 0) {
            return (item[1][3] = 0);
          } else {
            return (item[1][3] = this.optData / 400);
          }
        });
        //console.log(ledcolorList);
        if (this.gridDataList[this.timeLineData] != undefined) {
          // if (this.tilePixelLayer) {
          //   this.map.map.removeLayer(this.tilePixelLayer);
          //   this.tilePixelLayer = null;
          // }

          this.chooseGridData = this.gridDataList[this.timeLineData];
          // this.addMakerToMap(this.gridDataList[this.timeLineData]);
          let dataList = this.gridDataList[this.timeLineData].windS.map(
            item => {
              return Number(item);
            }
          );

          // ////console.log(dataList);
          this.windspeedLayer = L.tilePixelLayer({
            newData: dataList,
            data: this.gridDataList[this.timeLineData],
            gradient: ledcolorList
          });

          this.map.map.addLayer(this.windspeedLayer);
        }
      }
    },
    formatTooltip(val) {
      return val / 100;
    },
    openStrkHandell(data) {
      if (this.isOpenst == false) {
        let show = false;
        let t = this;
        this.isOpenstTimer = setInterval(() => {
          t.isOpenst = true;
          show = !show;
          t.showChooseArea(data, show);
        }, 1000);
      } else {
        clearInterval(this.isOpenstTimer);
        this.showChooseArea(data, false);
        this.isOpenst = false;
      }
    },
    showChooseArea(data, isshow) {
      let myusername = jsCookie.get("name");
      let areaList = data.area.split(",");
      let t = this;
      if (isshow) {
        if (myusername == "shimian") {
          this.wringLayer = L.geoJSON(shimian.features, {
            style: function() {
              return {
                color: t.waringIfoList.leaveType, //线颜色
                weight: 3, //线粗细
                opacity: 1, //透明度
                fillColor: t.waringIfoList.leaveType, //区域填充颜色
                fillOpacity: 0.5
              };
            },
            filter: function(geoJsonFeature) {
              return areaList.some(
                ele => ele === geoJsonFeature.properties.name
              );
            }
          }).addTo(this.map.map);
        } else if (myusername == "yingjing") {
          //console.log("L.mask");
          L.mask(yingjing, { fillOpacity: 0.7 }).addTo(this.map.map);
          this.wringLayer = L.geoJSON(yingjing.features, {
            style: function() {
              return {
                color: t.waringIfoList.leaveType, //线颜色
                weight: 3, //线粗细
                opacity: 1, //透明度
                fillColor: t.waringIfoList.leaveType, //区域填充颜色
                fillOpacity: 0.5
              };
            },
            filter: function(geoJsonFeature) {
              return areaList.some(
                ele => ele === geoJsonFeature.properties.name
              );
            }
          }).addTo(this.map.map);
        }
      } else {
        if (this.wringLayer != null) {
          this.map.map.removeLayer(this.wringLayer);
          this.wringLayer = null;
        }
      }
    },
    showwaringDelInfo(e) {
      //console.log(e);
      this.isShowwarningInfoBox = true;
      if (this.isOpenst == true) {
        clearInterval(this.isOpenstTimer);
        this.showChooseArea(this.waringIfoList, false);
        this.isOpenst = false;
      }
      this.waringIfoList = e;
      //console.log(this.waringIfoList);
    },
    getWaterInfoData() {
      if (this.watherLayer != null) {
        this.map.map.removeLayer(this.watherLayer);
        this.watherLayer = null;
      }
      let markerListData = [];
      // this.$axios({
      //   method: "get",
      //   url: `
      // /api/SWDataservice/interface/v1/api?interfaceId=getRiver&adcode=510000&key=5ffd1a30-44f8-4298-a84e-8cd83430bdaf`
      // })
      let formData = new FormData();
      formData.append("adcode", `510000`);
      this.$axios({
        method: "post",
        url: `http://120.79.183.250:3099/data/getRiver`,
        data: formData
      })
        .then(res => {
          //console.log(1111122);
          //console.log(res);
          //  "dataList": [{
          //         "bsnm": "长江",//流域名称，string类型
          //         "name": "望江楼",//站点名称，string类型
          //         "rvnm": "府河",//江河名，string类型
          //         "type": "河道站",//站点类型，string类型
          //         "lon": "104.084121",//经度，string类型
          //         "lat": "30.644412",//纬度，string类型
          //         "datatime": "12-03 14:00",//观测数据时间，string类型
          //         "ql": 0,//流量，double类型，单位：立方米/秒
          //         "zl": 486.73,//水位，double类型，单位：米
          //         "wrz": 487,//警戒水位，double类型，单位：米
          //         "warning": "false" //是否超警戒，string类型
          //     }, {
          // ////console.log(res.data.dataList);
          var greenIcon = L.icon({
            iconUrl: waterPng, //icon阴影图片路径

            iconSize: [32, 32] // size of the icon
          });

          res.data.map(item => {
            //  .addTo(this.map.map);
            markerListData.push(
              L.marker([item.lat, item.lon], { icon: greenIcon })
                .bindPopup(
                  `
              <p>流域名称:${item.bsnm}</p>
              <p>站点名称:${item.name}</p>
              <p>江河名:${item.rvnm}</p>
              <p>站点类型:${item.type}</p>
              <p>经度:${item.lon}</p>
              <p>纬度:${item.lat}</p>
              <p>观测数据时间:${item.datatime}</p>
              <p>流量:${item.ql}</p>
              <p>水位:${item.zl}</p>
              <p>警戒水位:${item.wrz}</p>
              <p>是否超警戒:${item.warning ? "超过" : "未超过"}</p>
              `
                )
                .openPopup()
            );
            // ////console.log(item);
          });
          this.watherLayer = L.layerGroup(markerListData).addTo(this.map.map);
          // this.waringList = res.data.dataList;
        })
        .catch(() => {});
    },
    arrChange(num, arr) {
      const newArr = [];
      while (arr.length > 0) {
        newArr.push(arr.splice(0, num));
      }
      return newArr;
    },
    addMakerToMap() {
      let data = this.chooseGridData;
      if (this.textmarkerLayer != null) {
        this.map.map.removeLayer(this.textmarkerLayer);
        this.textmarkerLayer = null;
      }
      let xySum = 1;
      let dataList = [];
      if (this.checkList == "大风") {
        dataList = data.windS.map(item => {
          return Number(item);
        });
        xySum = 1;
      } else if (this.checkList == "雷达") {
        dataList = data.datas.map(item => {
          return Number(item);
        });
        xySum = 10;
      } else {
        dataList = data.datas.split(",").map(item => {
          return Number(item);
        });
        xySum = 5;
      }
      let NewDataList = this.arrChange(data.cols, dataList);
      let index = 0;
      let xq = (data.right - data.left) / data.cols;
      let yq = (data.top - data.bottom) / data.rows;
      let makerList = [];
      for (let i = 0; i < data.rows; i += xySum) {
        for (let k = 0; k < data.cols; k += xySum) {
          let markerIcon = L.divIcon({
            html: `<div class="maerktext2">${NewDataList[i][k].toFixed(
              1
            )}</div>`, //marker标注
            className: "my-div-icon",
            iconSize: [10, 10], //marker宽高
            iconAnchor: [10, 10] //文字标注相对位置
          });
          // index++;
          makerList.push(
            L.marker([data.top - yq * i, data.left + xq * k], {
              icon: markerIcon
            })
          );
        }
      }
      this.textmarkerLayer = L.layerGroup(makerList).addTo(this.map.map);
    },
    isshownumchange(e) {
      // ////console.log(e);
      if (e) {
        this.addMakerToMap();
      } else {
        if (this.textmarkerLayer != null) {
          this.map.map.removeLayer(this.textmarkerLayer);
          this.textmarkerLayer = null;
        }
      }
    },
    drawMakerTomap(mygetdata1, mygetdata2, zindex, data) {
      //console.log(1111);
      //console.log(data);
      //console.log(mygetdata1);
      //console.log(mygetdata2);
      if (this.tilePixelLayer != null) {
        this.map.map.removeLayer(this.tilePixelLayer);
        this.tilePixelLayer = null;
      }

      let myNewdata = JSON.parse(JSON.stringify(mygetdata1));
      let myNewdata2 = JSON.parse(JSON.stringify(mygetdata2));
      // let boxData = []
      //console.log(myNewdata, myNewdata2);
      let ecBoxList = [];
      for (let i = 0; i < data.rows; i++) {
        let newlist = myNewdata.slice(i * data.cols, (i + 1) * data.cols);
        ecBoxList.push(newlist);
      }
      let ecBoxList2 = [];
      for (let i = 0; i < data.rows; i++) {
        let newlist = myNewdata2.slice(i * data.cols, (i + 1) * data.cols);
        ecBoxList2.push(newlist);
      }
      let nx = (data.right - data.left) / data.cols;
      let ny = (data.top - data.bottom) / data.rows;
      let top = data.top;
      let left = data.left;
      let makerList = [];
      for (let y = 0; y < data.rows; y += zindex) {
        for (let x = 0; x < data.cols; x += zindex) {
          //console.log(x, y);
          let windimg = wind1;
          if (ecBoxList[y][x] <= 0.2) {
            windimg = wind1;
          } else if (ecBoxList[y][x] <= 1.5) {
            windimg = wind2;
          } else if (ecBoxList[y][x] <= 3.3) {
            windimg = wind3;
          } else if (ecBoxList[y][x] <= 5.4) {
            windimg = wind4;
          } else if (ecBoxList[y][x] <= 7.9) {
            windimg = wind5;
          } else if (ecBoxList[y][x] <= 10.7) {
            windimg = wind6;
          } else if (ecBoxList[y][x] <= 13.8) {
            windimg = wind7;
          } else if (ecBoxList[y][x] <= 17.1) {
            windimg = wind8;
          } else if (ecBoxList[y][x] <= 20.7) {
            windimg = wind9;
          } else if (ecBoxList[y][x] <= 24.4) {
            windimg = wind9;
          } else if (ecBoxList[y][x] <= 28.4) {
            windimg = wind10;
          } else if (ecBoxList[y][x] <= 32.6) {
            windimg = wind11;
          } else if (ecBoxList[y][x] <= 36.9) {
            windimg = wind12;
          }
          //console.log(windimg);
          let markerIcon = L.divIcon({
            html: `<div class="maerktext" style='-moz-transform:rotate(${ecBoxList2[y][x]}deg);
  -webkit-transform:rotate(${ecBoxList2[y][x]}deg);'><img src="${windimg}"></img></div>`, //marker标注
            className: "testBoxIcon",
            iconSize: [10, 10], //marker宽高
            iconAnchor: [10, 10] //文字标注相对位置
          });

          makerList.push(
            L.marker([top - ny * y, left + nx * x], {
              icon: markerIcon
            })
          );
        }
      }
      // //console.log(makerList);
      this.tilePixelLayer = L.layerGroup(makerList).addTo(this.map.map);
      // });
    },
    getWaringData() {
      // let timeStr = new Date().getTime();
      // ////console.log();
      // let sinCode = md5(
      //   timeStr.toString().substring(0, 8) +
      //     "53A51DAC-8986-4A4B-B3BC-89585C897110"
      // );

      // this.$axios({
      //   method: "get",
      //   url: `https://int.scqx.net/?id=3019&sign=${sinCode.substring(0, 16)}`
      // }).then(res => {
      let myuserinfo = JSON.parse(jsCookie.get("areainfo"));
      let code = "5118";
      if (this.userareaCode == 511800) {
        code = "5118";
      } else {
        code = this.userareaCode;
      }
      this.$axios({
        method: "post",
        // url: `http://120.79.183.250:3099/warn/getYaanWarninfo`
        url: `http://120.79.183.250:3099/warn/getYaWarninfoByTime?startTime=${this.warningTime[0]}&endTime=${this.warningTime[1]}&areaCode=${code}`
      }).then(res => {
        //console.log(111111);
        console.log(res);
        // if (res.data.cdata == undefined) {
        this.waringList = res.data.datas;
        this.waringList2 = res.data.datas;

        // this.waringList2 = [
        //   {
        //     headline: "石棉发布暴雨红色预警",
        //     startTime: "2024-03-28 12:00:00",
        //     endTime: "2024-03-28 16:00:00",
        //     level: "红色预警",
        //     text: "可能造成相关区域地质灾害（滑坡）",
        //     areanum: "242平方千米",
        //     area: "美罗乡,迎政乡,宰羊乡,丰乐乡",
        //     tel: "182xxxxxxxx 王xx",
        //     leaveType: "red"
        //   },
        //   {
        //     headline: "石棉发布高温黄色预警",
        //     startTime: "2024-03-28 12:00:00",
        //     endTime: "2024-03-28 16:00:00",
        //     level: "黄色预警",
        //     text: "注意防晒",
        //     areanum: "242平方千米",
        //     area: "棉城街道,擦罗彝族乡,新棉镇",
        //     tel: "182xxxxxxxx",
        //     leaveType: "yellow"
        //   },
        //   {
        //     headline: "石棉发布大雾黄色预警",
        //     startTime: "2024-03-28 12:00:00",
        //     endTime: "2024-03-28 16:00:00",
        //     level: "黄色预警",
        //     text: "注意行车安全",
        //     areanum: "242平方千米",
        //     area: "宰羊乡,挖角彝族藏族乡,新棉镇",
        //     tel: "182xxxxxxxx",
        //     leaveType: "yellow"
        //   }
        // ];
        // } else {
        //   this.waringList = res.data.cdata;
        // }

        // this.weatherInfoData = res.data.cdata;
      });
    },
    getGridData(type) {
      // if (this.isplaying) {
      //   clearInterval(this.sldPlayTimeer);
      //   this.sldPlayTimeer = null;
      //   this.isplaying = !this.isplaying;
      //   // if (this.tilePixelLayer) {
      //   //   this.map.map.removeLayer(this.tilePixelLayer);
      //   //   this.tilePixelLayer = null;
      //   // }
      // }

      const loading = this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      if (this.tilePixelLayer) {
        this.map.map.removeLayer(this.tilePixelLayer);
        this.tilePixelLayer = null;
      }
      if (this.windspeedLayer) {
        this.map.map.removeLayer(this.windspeedLayer);
        this.windspeedLayer = null;
      }
      let formData = new FormData();

      formData.append(
        "para",
        `{"dateTime":"${moment()
          .subtract(1, "h")
          .format("YYYY-MM-DD HH:00:00")}","areaCode":"${
          this.userareaCode
        }","element":"${type}","forcastTime":"null"}`
      );
      // formData.append(
      //   "para",
      //   `{"dateTime":"2024-04-17 08:00:00","areaCode":"511824","element":"rain","forcastTime":"null"}`
      // );
      // formData.append("apiName", `grid,getForcastHour`);
      // formData.append("element", type);
      // formData.append("forcastTime", null);
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `http://120.79.183.250:3099/grid/getForcastHour2`,
        // url: `http://120.79.183.250:3099/SWDataservice/interface/customApi`,
        // url: `http:///SWDataservice/interface/customApi`,
        data: formData
      })
        .then(res => {
          let unzipList = JSON.parse(unzip(res.data.datas)).grid;
          // console.log(unzipList);
          this.gridDataList = [];
          if (type != "wind") {
            this.ledgonList = legendColor[type];
            //console.log(this.ledgonList);

            this.isShowWindLayer = false;
            let ledcolorList = JSON.parse(JSON.stringify(legendColor[type]));

            ledcolorList.map((item, index) => {
              ////console.log(index);
              if (index == 0) {
                return (item[1][3] = 0);
              } else {
                return (item[1][3] = this.optData / 100);
              }
            });
            console.log(unzipList);
            console.log(this.timeLineData);
            this.chooseGridData = unzipList[this.timeLineData];
            this.getlineMarker(unzipList[0].fTime);
            // console.log(this.chooseGridData[0].dTime);
            console.log(this.chooseGridData);
            let dataList = unzipList[this.timeLineData].datas
              .split(", ")
              .map(item => {
                return Number(item);
              });
            console.log(dataList);
            let t = this;
            this.gridDataList = unzipList;
            this.tilePixelLayer = L.tilePixelLayer({
              newData: dataList,
              data: unzipList[this.timeLineData],
              gradient: ledcolorList,
              clickEvt: function(e, gridValue) {
                console.log(e, gridValue);
                t.showEchartsBox(e);
              }
            });
            this.map.map.addLayer(this.tilePixelLayer);
            console.log(this.tilePixelLayer);
          } else {
            this.ledgonList = legendColor["windmy"];
            let ledcolorList = JSON.parse(
              JSON.stringify(legendColor["windmy"])
            );
            ledcolorList.map((item, index) => {
              ////console.log(index);
              if (index == 0) {
                return (item[1][3] = 0);
              } else {
                return (item[1][3] = this.optData / 100);
              }
            });
            let dataList = unzipList[this.timeLineData].windS.map(item => {
              return Number(item);
            });
            this.windspeedLayer = L.tilePixelLayer({
              newData: dataList,
              data: unzipList[this.timeLineData],
              gradient: ledcolorList
            });
            this.map.map.addLayer(this.windspeedLayer);
            this.isShowWindLayer = true;
            //console.log("wind");
            //console.log(res.data.grid);
            let firstData = unzipList[this.timeLineData];
            this.chooseGridData = unzipList[this.timeLineData];
            //console.log(firstData.windS);
            this.gridDataList = unzipList;
            this.drawMakerTomap(
              firstData.windS,
              firstData.windD,
              parseInt(20 / this.map.map.getZoom()),
              firstData
            );
          }

          // this.getlineMarker(res.data.result);
          loading.close();
          // this.waringList = res.data.dataList;
        })
        .catch(() => {
          loading.close();
        });
    },
    changeCloundData() {
      var myDate2 = new Date();
       let startTime = moment()
        .subtract(8, "h")
        .format("YYYYMMDDHH0000");
      let url =  `http://image.nmc.cn/product/${myDate2.getFullYear()}/${moment().format(
          "MM"
        )}/${moment(
          this.getimgTime,
          "YYYYMMDDHH00"
        )
          .subtract( 15*this.timeLineData, "m")
          .format("DD")}/WXBL/SEVP_NSMC_WXBL_FY4B_ETCC_ACHN_LNO_PY_${moment(
          this.getimgTime,
          "YYYYMMDDHH00"
        )
          .subtract( 15*this.timeLineData, "m")
          .format("YYYYMMDDHHmm")}00000.JPG`;
      console.log(url);
      // this.timeLineData
      let imageBounds = [
        [2, 60.0],
        [53, 139.5]
      ];
      // 将图片作为自定义图层加载到地图上（类似于Marker）
      this.imgLayer = L.imageOverlay(url, imageBounds, {
        opacity: 1,
        zIndex: 999
      });
      this.CloundDataGroup.addLayer(this.imgLayer);
    },
   async getCloundData() {
    let myNewUrl = "";

      var myDate2 = new Date();
      let startTime = moment()
        .subtract(8, "h")
        .format("YYYYMMDDHH0000");
      for (let i = 0; i < 20; i++) {
        // if (i == 522) {
        //   break;
        // }
        console.log(
          moment(startTime, "YYYYMMDDHH0000000")
            .subtract(i * 15, "m")
            .format("YYYYMMDDHHmm00000")
        );
        let url = `http://image.nmc.cn/product/${myDate2.getFullYear()}/${moment().format(
          "MM"
        )}/${moment(
          startTime,
          "YYYYMMDDHH00"
        )
          .subtract(i * 15, "m")
          .format("DD")}/WXBL/SEVP_NSMC_WXBL_FY4B_ETCC_ACHN_LNO_PY_${moment(
          startTime,
          "YYYYMMDDHH00"
        )
          .subtract(i * 15, "m")
          .format("YYYYMMDDHHmm")}00000.JPG`;
        // if()
        // console.log(url);
        let ishaveData = false;
        await this.isHasImg(url).then(res => {
          if (res) {
            console.log(res);
            this.getimgTime = startTime
            myNewUrl = url;
            ishaveData = true;
          }
        });
        if (ishaveData) {
          break;
        }
        // alert(i);
        // document.write(i);
      }
      let imageBounds = [
        [2, 60.0],
        [53, 139.5]
      ];
      // 将图片作为自定义图层加载到地图上（类似于Marker）
      this.imgLayer = L.imageOverlay(myNewUrl, imageBounds, {
        opacity: 1,
        zIndex: 999
      });
      this.CloundDataGroup = L.layerGroup([this.imgLayer]).addTo(this.map.map);
    },
       isHasImg(imgurl2) {
      return new Promise(function(resolve, reject) {
        var ImgObj = new Image(); //判断图片是否存在
        ImgObj.src = imgurl2;
        ImgObj.onload = function(res) {
          if (this.complete == true) {
            resolve(true); //正常返回true
          }
        };
        ImgObj.onerror = function(err) {
          resolve(false); //  图片异常 就返回false
        };
      });
    },
    getCloundData2() {
      let hash = md5("value");
      ////console.log(hash);
      let timeStr = new Date().getTime();
      ////console.log();
      let sinCode = md5(
        timeStr.toString().substring(0, 8) +
          "53A51DAC-8986-4A4B-B3BC-89585C897110"
      );
      ////console.log(sinCode.substring(0, 16));

      this.$axios({
        method: "get",
        url: `https://int.scqx.net/?id=3038&sign=${sinCode.substring(0, 16)}`
      }).then(res => {
        if (res.data.cdata == undefined) {
          let imageBounds = [
            [2, 60.0],
            [53, 139.5]
          ];
          // 将图片作为自定义图层加载到地图上（类似于Marker）
          this.imgLayer = L.imageOverlay(
            "http://file.scqx.net/file/general/sat/20240304164500.jpg",
            imageBounds,
            { opacity: 1, zIndex: 999 }
          ).addTo(this.map.map);
        } else {
          let imageBounds = [
            [2, 60.0],
            [53, 139.5]
          ];
          // 将图片作为自定义图层加载到地图上（类似于Marker）
          this.imgLayer = L.imageOverlay(res.data.cdata[0].url, imageBounds, {
            opacity: 1,
            zIndex: 999
          }).addTo(this.map.map);
        }

        // //console.log(res.data.cdata[0].url);
        // this.isShowClound = true;
        // this.cloundImg = res.data.cdata;
      });
    },
    showPlaceStationToMap() {
      // if (this.movePlaceLayer != null) {
      //   this.map.map.removeLayer(this.movePlaceLayer);
      //   this.movePlaceLayer = null;
      // }
      let formData = new FormData();
      formData.append(
        "para",
        `{"deviceId":"null","deviceName":"null","deviceCode":"null","deviceTypeName":"null","areaCode":"null","Province":"null","City":"null","Country":"null","typeCode":"null","typeName":"${this.checkList}"}`
      );
      this.$axios({
        method: "post",
        url: `
       http://120.79.183.250:3099/device/getDeformationStation`,
        data: formData
      }).then(res => {
        console.log(res);

        let moveIcon = L.icon({
          iconUrl: movePng, //icon阴影图片路径

          iconSize: [32, 29] // size of the icon
        });
        if (this.checkList == "GNSS连续站" || this.checkList == "GNSS区域站") {
          moveIcon = L.icon({
            iconUrl: movePng2, //icon阴影图片路径

            iconSize: [32, 29] // size of the icon
          });
        } else if (
          this.checkList == "跨断层水准测距综合场地" ||
          this.checkList == "跨断层水准场地"
        ) {
          moveIcon = L.icon({
            iconUrl: movePng3, //icon阴影图片路径

            iconSize: [32, 29] // size of the icon
          });
        } else if (
          this.checkList == "重力" ||
          this.checkList == "流动地磁矢量" ||
          this.checkList == "流动地磁总强度" ||
          this.checkList == "蠕变动态观测台"
        ) {
          moveIcon = L.icon({
            iconUrl: movePng4, //icon阴影图片路径

            iconSize: [32, 29] // size of the icon
          });
        }
        let markerList = [];
        res.data.map(item => {
          markerList.push(
            L.marker([item.Lat, item.Lon], { icon: moveIcon })
              .bindPopup(
                `
              <p>城市:${item.City}</p>
              <p>区县:${item.Country}</p>
              <p>站点:${item.deviceName}</p>
              <p>站号:${item.deviceId}</p>
              <p>经度:${item.Lon}</p>
              <p>纬度:${item.Lat}</p>
              <p>类型:${item.deviceTypeName}</p>
              `
              )
              .openPopup()
          );
        });
        this.movePlaceLayer = L.layerGroup(markerList).addTo(this.map.map);
      });
    },
    showTypeChange(e) {
           if (this.imgLayer != null) {
          this.map.map.removeLayer(this.imgLayer);
          this.imgLayer = null;
        }
          this.isShowdaizailegon=false
      this.isShowWarningLayer = false;
      this.isShowWindLayer = false;
      if (this.lightningLayer != null) {
        this.map.map.removeLayer(this.lightningLayer);
        this.lightningLayer = null;
      }
      if (this.movePlaceLayer != null) {
        this.map.map.removeLayer(this.movePlaceLayer);
        this.movePlaceLayer = null;
      }
      if (this.isplaying) {
        clearInterval(this.sldPlayTimeer);
        this.sldPlayTimeer = null;
        this.isplaying = !this.isplaying;
      }
      if (this.CloundDataGroup != null) {
        this.map.map.removeLayer(this.CloundDataGroup);
        this.CloundDataGroup = null;
      }
      if (this.windspeedLayer) {
        this.map.map.removeLayer(this.windspeedLayer);
        this.windspeedLayer = null;
      }
        if (this.imgLayer != null) {
          this.map.map.removeLayer(this.imgLayer);
          this.imgLayer = null;
        }
      if (this.tilePixelLayer) {
        this.map.map.removeLayer(this.tilePixelLayer);
        this.tilePixelLayer = null;
      }
      if (this.checkList2 == "地质") {
        this.isShowWindLayer = false;
        if (e == "GNSS自建站") {
          this.getwaringListplaceData();
        } else {
          this.showPlaceStationToMap();
        }
      } else if (this.checkList2 == "气象") {
        if (e == "雨量") {
          this.getGridData("rain");
        } else if (e == "温度") {
          this.getGridData("tem");
        } else if (e == "大风") {
          this.isShowWindLayer = true;
          this.getGridData("wind");
          // this.isSHowtimeled = false;
          // this.isshowmyoptbtn = false;
        } else if (e == "闪电") {
          this.getLightningData();
        } else if (e == "云图") {
          this.getCloundData();
        } else if (e == "雷达") {
          this.getRadarData();
        }
      } else if (this.checkList2 == "重点关注") {
        this.getDangerDataList();
      }
    },
    getRadarData() {
      const loading = this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      if (this.tilePixelLayer) {
        this.map.map.removeLayer(this.tilePixelLayer);
        this.tilePixelLayer = null;
      }
      let type = "rain";
      if (this.checkList == "雨量") {
        type = "rain";
      } else if (this.checkList == "温度") {
        type = "tem";
        // this.getGridData("tem");
      } else if (this.checkList == "大风") {
        type = "wind";
        // this.getGridData("wind_s");
      } else if (this.checkList == "雷达") {
        type = "radar";
        // this.getGridData("wind_s");
      }
      let formData = new FormData();

      formData.append(
        "para",
        `{"dateTime":"null","areaCode":"${this.userareaCode}","element":"rain","forcastTime":"null"}`
      );
      this.$axios({
        method: "post",
        url: `http://120.79.183.250:3099/grid/getRadarForcastHour2`,
        data: formData
      })
        .then(res => {
          let unzipList = JSON.parse(unzip(res.data.datas)).grid;
          //console.log(res.data.grid);
          this.ledgonList = legendColor[type];
          //console.log(this.ledgonList);

          this.isShowWindLayer = false;
          let ledcolorList = JSON.parse(JSON.stringify(legendColor[type]));

          ledcolorList.map((item, index) => {
            ////console.log(index);
            if (index == 0) {
              return (item[1][3] = 0);
            } else {
              return (item[1][3] = this.optData / 100);
            }
          });

          this.chooseGridData = unzipList[this.timeLineData];
          let dataList = unzipList[this.timeLineData].datas.map(item => {
            return Number(item);
          });
          console.log(dataList);
          let t = this;
          this.gridDataList = unzipList;
          this.tilePixelLayer = L.tilePixelLayer({
            newData: dataList,
            data: unzipList[this.timeLineData],
            gradient: ledcolorList
            // clickEvt: function(e, gridValue) {
            //   console.log(e, gridValue);
            //   let popup = L.popup()
            //     .setLatLng([e.latlng.lat, e.latlng.lng])
            //     .setContent(`<div>${t.checkList}值:${gridValue}</div>`)
            //     .openOn(t.map.map);
            // }
          });
          this.map.map.addLayer(this.tilePixelLayer);
          loading.close();
          // this.waringList = res.data.cdata;
          // this.weatherInfoData = res.data.cdata;
        })
        .catch(() => {
          loading.close();
        });
    },
    getLightningData() {
      var hash = md5("value");
      ////console.log(hash);
      let timeStr = new Date().getTime();
      ////console.log();
      let sinCode = md5(
        timeStr.toString().substring(0, 8) +
          "53A51DAC-8986-4A4B-B3BC-89585C897110"
      );
      ////console.log(sinCode.substring(0, 16));
      let markerList = [];
      this.$axios({
        method: "get",
        url: `https://int.scqx.net/?id=3036&sign=${sinCode.substring(0, 16)}`
      }).then(res => {
        //console.log(res.data.cdata);
        if (res.data.status != "105") {
          this.lightningData = res.data.cdata;
        }
        this.lightningData.map(item => {
          let myIcon = L.icon({
            iconUrl: require("../assets/lintinfg.png"),
            iconSize: [30, 30],

            popupAnchor: [-15, -15]
          });

          markerList.push(L.marker([item.lat, item.lng], { icon: myIcon }));
        });
        this.lightningLayer = L.layerGroup(markerList).addTo(this.map.map);
        // this.weatherInfoData = res.data.cdata;
      });
    },
    extendCheckChange(e) {
      // console.log(e);
      if (e.indexOf("水系") != -1) {
        if (this.isSHowWarter) {
          this.waterLayer = L.geoJSON(WaterJson.features).addTo(this.map.map);
        } else {
          if (this.waterLayer != null) {
            this.map.map.removeLayer(this.waterLayer);
            this.waterLayer = null;
          }
        }
      }
      if (e.indexOf("路网") != -1) {
        if (this.isShowRold) {
          this.roldLayer = L.geoJSON(roldJson.features, {
            style: {
              color: "#fff200", //线颜色
              weight: 1, //线粗细
              opacity: 1, //透明度
              fillColor: "#fff200", //区域填充颜色
              fillOpacity: 0 //区域填充颜色的透明
            }
          }).addTo(this.map.map);
        } else {
          if (this.roldLayer != null) {
            this.map.map.removeLayer(this.roldLayer);
            this.roldLayer = null;
          }
        }
      }
      if (e.indexOf("居民区") != -1) {
        if (this.isShowHouse) {
          this.peoLayer = L.geoJSON(peoJson.features, {
            style: {
              color: "red", //线颜色
              weight: 1, //线粗细
              opacity: 1, //透明度
              fillColor: "red", //区域填充颜色
              fillOpacity: 0 //区域填充颜色的透明
            }
          }).addTo(this.map.map);
        } else {
          if (this.peoLayer != null) {
            this.map.map.removeLayer(this.peoLayer);
            this.peoLayer = null;
          }
        }
      }
      if (e.indexOf("水位") != -1) {
        if (this.isShowwater) {
          this.getWaterInfoData();
        } else {
          if (this.watherLayer != null) {
            this.map.map.removeLayer(this.watherLayer);
            this.watherLayer = null;
          }
        }
      }
    },
    getweatherData() {
      this.$axios({
        method: "post",
        url: `
        http://120.79.183.250:3099/data/getActualElementsByPosition?Longitude=103.009&Latitude=29.999`,
        // url: `
        // /api/SWDataservice/interface/v1/api?interfaceId=getActualElementsByPosition&Longitude=103.009&Latitude=29.999`,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(res => {
        //console.log(111);
        //console.log(res.data);
        this.weatherdata = res.data[0];
        // this.waringList = res.data.dataList;
      });
    },
    getrgb(data) {
      //// ////console.log(data);
      //// ////console.log(`rgb(${data[1][0]},${data[1][1]},${data[1][2]})`);
      return `rgb(${data[1][0]},${data[1][1]},${data[1][2]})`;
    },
    palyvideo(url) {
      this.videoPlayer = Videojs(document.querySelector("#mmiid"), {
        autoplay: "muted", //自动播放
        controls: true, //用户可以与之交互的控件
        loop: true, //视频一结束就重新开始
        muted: false, //默认情况下将使所有音频静音
        aspectRatio: "16:9", //显示比率
        fullscreen: {
          options: { navigationUI: "hide" }
        },
        techOrder: ["html5", "flvjs"], // 兼容顺序
        html5: {
          hls: {
            withCredentials: true
          }
        },
        sources: [
          {
            src: url,
            type: "application/x-mpegURL"
          }
        ]
      });
    },
    checkList2change(e) {
      if (this.watherLayer != null) {
        this.map.map.removeLayer(this.watherLayer);
        this.watherLayer = null;
      }
         if (this.movePlaceLayer != null) {
        this.map.map.removeLayer(this.movePlaceLayer);
        this.movePlaceLayer = null;
      }
      if (this.movePlaceLayer != null) {
        this.map.map.removeLayer(this.movePlaceLayer);
        this.movePlaceLayer = null;
      }
      if (this.tilePixelLayer) {
        this.map.map.removeLayer(this.tilePixelLayer);
        this.tilePixelLayer = null;
      }
      if (this.windspeedLayer) {
        this.map.map.removeLayer(this.windspeedLayer);
        this.windspeedLayer = null;
      }
      if (e == "气象") {
        this.checkListdata = ["雨量", "温度", "云图", "雷达"];
        this.checkList = "雨量";
        this.showTypeChange("雨量");
      } else if (e == "地质") {
        this.isShowWindLayer = false;
        this.getwaringListplaceData();
        // this.checkListdata = ["地灾", "位移", "沉降"];
        this.checkListdata = [
          "GNSS自建站",
          "跨断层水准测距综合场地",
          "跨断层水准场地",
          "GNSS区域站",
          "GNSS连续站",
          "重力",
          "流动地磁矢量",
          "流动地磁总强度",
          "蠕变动态观测台"
        ];
        this.checkList = "GNSS自建站";
      } else if (e == "重点关注") {
        // this.getwaringListplaceData();
        // this.checkListdata = ["地灾", "位移", "沉降"];
        this.checkListdata = ["地灾隐患点", "重点观测点"];
        this.checkList = "地灾隐患点";
        this.getDangerDataList();
      }
      // else {
      //   this.getWaterInfoData();
      // }
    },
    getwaringListplaceData() {
      let formData = new FormData();

      formData.append(
        "para",
        `{"startTime":"null","endTime":"null","deviceId":"null","deviceType":"L1_GP_1","xStart":"null","xEnd":"null","yStart":"null","yEnd":"null","zStart":"null","zEnd":"null"}`
      );

      this.$axios({
        method: "post",
        url: `http://120.79.183.250:3099/device/getGnssData`,
        data: formData
      }).then(res => {
        //console.log(res.data);
        let moveIcon = L.icon({
          iconUrl: movePng, //icon阴影图片路径

          iconSize: [25, 25] // size of the icon
        });
        // movePlaceLayer
        let markerList = [];
        res.data.map(item => {
          markerList.push(
            L.marker([item.lat, item.lon], { icon: moveIcon })
              .bindPopup(
                `
              <p>城市:${item.city}</p>
              <p>区县:${item.country}</p>
              <p>时间:${item.dateTime}</p>
              <p>站点:${item.deviceName}</p>
              <p>经度:${item.lon}</p>
              <p>纬度:${item.lat}</p>
              <p>类型:${item.deviceTypeName}</p>
              <p>x轴位移:${item.xOffset}</p>
              <p>y轴位移:${item.yOffset}</p>
              <p>z轴位移:${item.zOffset}</p>
         
              `
              )
              .openPopup()
          );
        });
        this.movePlaceLayer = L.layerGroup(markerList).addTo(this.map.map);
        // this.waringListplace = res.data;
        // //console.log(res.data.datas[0]);
      });
    },
    palyHander() {
      this.isplaying = !this.isplaying;
      if (this.isplaying) {
        this.isshownum = false;
        this.isshownumchange(this.isshownum);
        this.sldPlayTimeer = setInterval(() => {
          if (this.timeLineData == this.slidMaxdata) {
            this.timeLineData = 0;
          } else {
            this.timeLineData = this.timeLineData + 1;
          }
          if (this.checkList == "云图") {
            // console.log(212121);
            this.changeCloundData();
          } else {
            this.changeMapGrid();
          }
        }, 1000);
      } else {
        clearInterval(this.sldPlayTimeer);
        this.sldPlayTimeer = null;
      }
    },
    showTimeCheng() {
      if (this.checkList == "云图") {
        // console.log(212121);
        this.changeCloundData();
      } else {
        this.changeMapGrid();
      }
    },
    changeMapGrid() {
      let type = "rain";
      if (this.checkList == "雨量") {
        type = "rain";
      } else if (this.checkList == "温度") {
        type = "tem";
        // this.getGridData("tem");
      } else if (this.checkList == "大风") {
        type = "wind";
        // this.getGridData("wind_s");
      } else if (this.checkList == "雷达") {
        type = "radar";
        // this.getGridData("wind_s");
      }
      if (type != "wind") {
        let ledcolorList = JSON.parse(JSON.stringify(legendColor[type]));
        ledcolorList.map((item, index) => {
          ////console.log(index);
          if (index == 0) {
            return (item[1][3] = 0);
          } else {
            return (item[1][3] = this.optData / 400);
          }
        });
        if (this.gridDataList[this.timeLineData] != undefined) {
          // if (this.tilePixelLayer) {
          //   this.map.map.removeLayer(this.tilePixelLayer);
          //   this.tilePixelLayer = null;
          // }

          this.chooseGridData = this.gridDataList[this.timeLineData];
          // this.addMakerToMap(this.gridDataList[this.timeLineData]);
          let dataList = [];
          if (type == "radar") {
            dataList = this.gridDataList[this.timeLineData].datas.map(item => {
              return Number(item);
            });
          } else {
            dataList = this.gridDataList[this.timeLineData].datas
              .split(",")
              .map(item => {
                return Number(item);
              });
          }
          //console.log(dataList);
          let oldTitle = this.tilePixelLayer;
          // ////console.log(dataList);
          let t = this;
          this.tilePixelLayer = L.tilePixelLayer({
            newData: dataList,
            data: this.gridDataList[this.timeLineData],
            gradient: ledcolorList,
            clickEvt: function(e, gridValue) {
              console.log(e, gridValue);
              t.showEchartsBox(e);
            }
          });
          // this.map.map.on("layeradd", () => {
          //   console.log("layeradd");
          //   this.map.map.removeLayer(oldTitle);
          // });
          this.map.map.addLayer(this.tilePixelLayer);
          setTimeout(() => {
            this.map.map.removeLayer(oldTitle);
          }, 1000);
        }
      } else {
        if (this.tilePixelLayer) {
          this.map.map.removeLayer(this.tilePixelLayer);
          this.tilePixelLayer = null;
        }
        if (this.gridDataList[this.timeLineData] != undefined) {
          this.drawMakerTomap(
            this.gridDataList[this.timeLineData].windS,
            this.gridDataList[this.timeLineData].windD,
            parseInt(20 / this.map.map.getZoom()),
            this.gridDataList[this.timeLineData]
          );
          let ledcolorList = JSON.parse(JSON.stringify(legendColor["windmy"]));

          ledcolorList.map((item, index) => {
            ////console.log(index);
            if (index == 0) {
              return (item[1][3] = 0);
            } else {
              return (item[1][3] = this.optData / 400);
            }
          });
          if (this.gridDataList[this.timeLineData] != undefined) {
            // if (this.tilePixelLayer) {
            //   this.map.map.removeLayer(this.tilePixelLayer);
            //   this.tilePixelLayer = null;
            // }

            this.chooseGridData = this.gridDataList[this.timeLineData];
            // this.addMakerToMap(this.gridDataList[this.timeLineData]);
            let dataList = this.gridDataList[this.timeLineData].windS.map(
              item => {
                return Number(item);
              }
            );
            //console.log(dataList);
            let oldTitle = this.windspeedLayer;
            // ////console.log(dataList);
            let t = this;
            this.windspeedLayer = L.tilePixelLayer({
              newData: dataList,
              data: this.gridDataList[this.timeLineData],
              gradient: ledcolorList
              // clickEvt: function(e, gridValue) {
              //   console.log(e, gridValue);
              //   let popup = L.popup()
              //     .setLatLng([e.latlng.lat, e.latlng.lng])
              //     .setContent(`<div>${t.checkList}值:${gridValue}</div>`)
              //     .openOn(t.map.map);
              // }
            });

            this.map.map.addLayer(this.windspeedLayer);
            setTimeout(() => {
              this.map.map.removeLayer(oldTitle);
            }, 1000);
          }
        }
      }

      // this.isshownumchange(this.isshownum);
    },
    getlineMarker(dateTime) {
      let diffTime = moment().diff(
        moment(dateTime, "YYYY-MM-DD HH:mm:ss"),
        "h"
      );
      this.timeLineData = diffTime;
      // console.log();
      let newdate = moment(dateTime, "YYYY-MM-DD HH:mm:ss").format("HH:00");
      // ////console.log(newdate);
      let marker = {};
      for (let i = 0; i < 24; i++) {
        //// ////console.log(i);
        if (i % 2 == 0) {
          marker[i] = {
            style: {
              color: "white"
            },
            label: moment(newdate, "HH:mm")
              .add(i, "h")
              .format("HH:mm")
          };
        }
      }
      // ////console.log(marker);
      this.marks = marker;
    }
  }
};
</script>

<style lang="scss" scoped>
@function px2vw($px) {
  @return $px * 100vw / 1920;
}
.watchBody {
  height: 100vh;
  width: 100vw;
  background-color: aqua;
  overflow: hidden;
}
.maerktext {
  font-size: px2vw(8);
  color: white;
}
.maerktext2 {
  font-size: px2vw(12);
  color: rgb(255, 255, 255);
  background-color: #1e4e4e83;
  // padding: 2px;
  width: 15px;
  text-align: center;
}
.leftConBox {
  position: absolute;
  left: 0;
  z-index: 999;
  pointer-events: none;
  width: px2vw(650);
  height: px2vw(1080);
  background: linear-gradient(
    270deg,
    rgba(17, 32, 37, 0) 0%,
    rgba(17, 32, 37, 0.9) 69.84%
  );
}
.rightConBox {
  position: absolute;
  right: 0;
  z-index: 999;
  width: px2vw(650);
  height: px2vw(1080);
  pointer-events: none;
  background: linear-gradient(
    90deg,
    rgba(17, 32, 37, 0) 0%,
    rgba(17, 32, 37, 0.9) 69.84%
  );
}
.weatherBox {
  position: absolute;
  top: px2vw(80);
  left: px2vw(30);
  pointer-events: auto;
  // background-color: aqua;
  // width: 400px;
  // width: 4rem;
  width: px2vw(400);
  height: px2vw(300);
  /* border-width: 1px;
  border-style: solid;
  border-image-source: linear-gradient(270deg, rgba(34, 67, 77, 0.6) 0%, rgba(29, 62, 70, 1) 100%);
  border-image-slice: 1;
  box-sizing: border-box;
  background: linear-gradient(270deg, rgba(17, 32, 37, 0.1) 0%, rgba(22, 39, 45, 0.5) 100%); */
}
.weatherTitle {
  width: px2vw(400);
  height: px2vw(46);
  background-image: url("../assets/Group_48097197.png");
  /* background-color: aqua; */
  background-size: cover;
}
.weatherTitText {
  width: px2vw(120);
  height: px2vw(22);
  position: relative;
  top: px2vw(18);
  left: px2vw(18);
  text-align: center;
  background: linear-gradient(
    180deg,
    rgba(219, 249, 255, 1) 32.78%,
    rgba(169, 240, 255, 1) 78.3%
  );
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent;
  font-family: DingTalk JinBuTi;
  font-size: px2vw(18);
  line-height: 120.000005%;
  letter-spacing: 10%;
}
.weatherMainBox {
  width: px2vw(400);
  height: px2vw(260);
  border-width: 1px;
  border-style: solid;
  border-image-source: linear-gradient(
    270deg,
    rgba(34, 67, 77, 0.6) 0%,
    rgba(29, 62, 70, 1) 100%
  );
  border-image-slice: 1;
  box-sizing: border-box;
  background: linear-gradient(
    270deg,
    rgba(17, 32, 37, 0.1) 0%,
    rgba(22, 39, 45, 0.5) 100%
  );
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  align-content: space-around;
}
.weatherMainBoxItem {
  width: px2vw(184);
  height: px2vw(70);
  background-image: url("../assets/Group_48097436.png");
  background-size: cover;
}
.weatherMainBoxItem2 {
  width: px2vw(184);
  height: px2vw(70);
  background-image: url("../assets/Group_48097436_1.png");
  background-size: cover;
}
.weatherMainBoxItem3 {
  width: px2vw(184);
  height: px2vw(70);
  background-image: url("../assets/Group_48097436_2.png");
  background-size: cover;
}
.weatherMainBoxItem4 {
  width: px2vw(184);
  height: px2vw(70);
  background-image: url("../assets/Group_48097436_3.png");
  background-size: cover;
}
.weatherMainBoxItem5 {
  width: px2vw(184);
  height: px2vw(70);
  background-image: url("../assets/Group_48097436_4.png");
  background-size: cover;
}
.weatherMainBoxItem6 {
  width: px2vw(184);
  height: px2vw(70);
  background-image: url("../assets/Group_48097436_5.png");
  background-size: cover;
}
.weatherText {
  background: linear-gradient(
    180deg,
    rgba(219, 249, 255, 1) 32.78%,
    rgba(169, 240, 255, 1) 78.3%
  );
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent;
  font-family: Microsoft YaHei;
  font-size: px2vw(14);
  line-height: 120.000005%;
  letter-spacing: 10%;
  position: relative;
  left: px2vw(80);
  line-height: px2vw(30);
}
.weatherinfotext {
  background: linear-gradient(
    180deg,
    rgba(219, 249, 255, 1) 32.78%,
    rgba(169, 240, 255, 1) 78.3%
  );
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent;
  font-family: DingTalk JinBuTi;
  font-size: px2vw(24);
  line-height: 120.000005%;
  letter-spacing: 10%;
  position: relative;
  left: px2vw(80);
  line-height: px2vw(30);
}
.videoBox {
  position: absolute;
  top: px2vw(80);
  right: px2vw(30);
  pointer-events: auto;
  // background-color: aqua;
  width: px2vw(400);
  height: px2vw(300);
}
.warningInfoText {
  width: px2vw(720);
  height: px2vw(36);
  background: linear-gradient(
    180deg,
    rgba(19, 92, 114, 0.71) 0%,
    rgba(11, 59, 73, 0.65) 17.16%,
    rgba(14, 92, 116, 0.49) 35.04%,
    rgba(14, 69, 86, 0.61) 64.84%,
    rgba(14, 50, 61, 0.69) 100%
  );
  position: absolute;
  top: px2vw(90);
  left: px2vw(600);
  z-index: 999;
  // transform: translateX(-px2vw(260));
  // text-align: center;
  line-height: px2vw(36);
  color: rgb(255, 255, 255);
  /* background: linear-gradient(
    180deg,
    rgba(255, 238, 181, 1) 20.38%,
    rgba(255, 255, 255, 1) 81.16%
  ); */
  /* -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent; */
  font-family: Microsoft YaHei UI;
  /* font-weight: bold; */
  font-size: px2vw(15);
  font-weight: 700;
  overflow: hidden;
  padding: 0 0 0 px2vw(100);
  /* color: #e7e2c0; */
  /* letter-spacing: 10%; */
  background-image: url("../assets/Group_1321314686.png");
  background-size: cover;
}
@keyframes around1 {
  from {
    left: 0;
  }
  to {
    /* left: calc(0px - var(--textWidth--) - 10px); */
    left: -100%;
  }
}
// .warningInfoText span {
//   /* width: 80%; */
//   position: absolute;
//   left: 0;
//   margin: 0 px2vw(10);
//   white-space: nowrap;
//   animation: around1 10s linear infinite;
// }
.videoMainBox {
  width: px2vw(400);
  height: px2vw(250);
  border: 1px solid rgba(48, 92, 108, 1);
  box-sizing: border-box;
}
/* .videoListbox {
  height: 80px;
  width: 95%;

  display: flex;
  justify-content: space-around;
  align-content: space-around;
  flex-wrap: wrap;
} */
.myviewSelect {
  height: px2vw(30) !important;
}
.videoListbox {
  // background-color: #32dcfe;
  position: absolute;
  top: px2vw(20);
  right: px2vw(30);
}
.videoListboxItem {
  width: px2vw(116);
  height: px2vw(30);
  background-color: aqua;
  background-image: url("../assets/85412.png");
  color: rgba(102, 182, 200, 1);
  font-family: Microsoft YaHei;
  font-size: px2vw(12);
  text-align: center;
  line-height: px2vw(30);
  background-size: cover;
}
.msgBox {
  position: absolute;
  top: px2vw(720);
  left: px2vw(30);
  /* background-color: aqua; */
  width: px2vw(400);
  height: px2vw(180);
  /* border-width: 1px;
  border-style: solid;
  border-image-source: linear-gradient(270deg, rgba(34, 67, 77, 0.6) 0%, rgba(29, 62, 70, 1) 100%);
  border-image-slice: 1;
  box-sizing: border-box;
  background: linear-gradient(270deg, rgba(17, 32, 37, 0.1) 0%, rgba(22, 39, 45, 0.5) 100%); */
}
.warningInfoTextItem {
  margin-left: px2vw(100);
  // background-color: red;
  width: 100%;
  overflow: hidden;
  position: relative;
  height: 100%;
}
@keyframes around222 {
  from {
    left: 100%;
  }

  to {
    /* left: calc(0px - var(--textWidth--) - 10px); */
    left: -100%;
  }
}
// .warningInfoTextItem span {
//   position: absolute;
//   top: 0;
//   left: 0;
// }
.warningInfoTextItem span {
  /* width: 80%; */
  position: absolute;
  left: 0;
  top: 0;
  z-index: 9999;
  margin: 0 px2vw(10);
  white-space: nowrap;
  animation: around222 10s linear infinite;
}
.msgMainBox {
  width: px2vw(400);
  height: px2vw(126);
  border-width: 1px;
  border-style: solid;
  border-image-source: linear-gradient(
    270deg,
    rgba(34, 67, 77, 0.6) 0%,
    rgba(29, 62, 70, 1) 100%
  );
  border-image-slice: 1;
  box-sizing: border-box;
  background: linear-gradient(
    270deg,
    rgba(17, 32, 37, 0.1) 0%,
    rgba(22, 39, 45, 0.5) 100%
  );
  padding: px2vw(14);
}
.msgMainBoxItem {
  width: px2vw(372);
  height: px2vw(26);
  background: rgba(0, 170, 255, 0.08);
  display: flex;
  align-items: center;
  color: rgba(198, 248, 255, 1);
  font-family: Microsoft YaHei;
  font-size: px2vw(12);
  padding: px2vw(5);
  margin-top: px2vw(5);
}
.msgMainBoxItem2 {
  position: absolute;
  top: px2vw(900);
  left: px2vw(30);
  /* background: rgba(0, 170, 255, 0.08); */
  display: flex;
  align-items: center;
  color: rgba(198, 248, 255, 1);
  font-family: Microsoft YaHei;
  font-size: px2vw(12);
  padding: px2vw(5);
  margin-top: px2vw(5);
  // display: flex;
  // justify-content: flex-end;
}
.warningBox {
  position: absolute;
  top: px2vw(500);
  /* left: 1490px; */
  left: px2vw(30);
  pointer-events: auto;
  /* background-color: aqua; */
  width: px2vw(400);
  height: px2vw(300);
}
.Earthquake {
  position: absolute;
  top: px2vw(290);
  pointer-events: auto;
  /* left: 1490px; */
  left: px2vw(30);
  /* background-color: aqua; */
  width: px2vw(400);
  // height: px2vw(300);
}
.warningMainBox {
  width: px2vw(400);
  height: px2vw(260);
  border-width: 1px;
  border-style: solid;
  border-image-source: linear-gradient(
    270deg,
    rgba(34, 67, 77, 0.6) 0%,
    rgba(29, 62, 70, 1) 100%
  );
  border-image-slice: 1;
  box-sizing: border-box;
  background: linear-gradient(
    270deg,
    rgba(17, 32, 37, 0.1) 0%,
    rgba(22, 39, 45, 0.5) 100%
  );
  padding: px2vw(5);
  overflow-y: auto;
  overflow-x: hidden;
}
.warningMainBox2 {
  width: px2vw(400);
  height: px2vw(160);
  border-width: 1px;
  border-style: solid;
  border-image-source: linear-gradient(
    270deg,
    rgba(34, 67, 77, 0.6) 0%,
    rgba(29, 62, 70, 1) 100%
  );
  border-image-slice: 1;
  box-sizing: border-box;
  background: linear-gradient(
    270deg,
    rgba(17, 32, 37, 0.1) 0%,
    rgba(22, 39, 45, 0.5) 100%
  );
  padding: px2vw(5);
  overflow-y: auto;
  overflow-x: hidden;
}
.warningMainBox2::-webkit-scrollbar {
  display: none;
}
.warningMainBox::-webkit-scrollbar {
  display: none;
}
.warningMainBoxItem {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: px2vw(380);
  height: px2vw(38);
  border-width: 1px;
  border-style: solid;
  border-image-source: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0.17) 0%,
    rgba(255, 255, 255, 0.17) 8.61%,
    rgba(255, 255, 255, 0.17) 90.61%,
    rgba(0, 0, 0, 0.17) 100%
  );
  border-image-slice: 1;
  box-sizing: border-box;
  background: rgba(27, 55, 67, 0.68);
  box-shadow: 0px 0px 9px rgba(160, 211, 233, 0.08) inset;
  color: rgba(198, 248, 255, 1);
  font-family: Microsoft YaHei;
  font-size: px2vw(14);
  line-height: px2vw(38);
  padding: 0px px2vw(5);
  margin-top: px2vw(10);
  z-index: 9999;
}
.warningMainBoxItem33 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: px2vw(380);
  height: px2vw(38);
  border-width: 1px;
  border-style: solid;
  border-image-source: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0.17) 0%,
    rgba(255, 255, 255, 0.17) 8.61%,
    rgba(255, 255, 255, 0.17) 90.61%,
    rgba(0, 0, 0, 0.17) 100%
  );
  border-image-slice: 1;
  box-sizing: border-box;
  background: rgba(27, 55, 67, 0.68);
  box-shadow: 0px 0px 9px rgba(160, 211, 233, 0.08) inset;
  color: rgba(198, 248, 255, 1);
  font-family: Microsoft YaHei;
  font-size: px2vw(10);
  line-height: px2vw(38);
  padding: 0px px2vw(5);
  margin-top: px2vw(10);
  z-index: 9999;
}
.warningBtn {
  width: px2vw(42);
  height: px2vw(19);
  background-image: url("../assets/Group_1321314701.png");
  background-size: cover;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: px2vw(12);
  color: #c5f3f8;
  text-align: center;
  line-height: px2vw(19);
  background-size: cover;
}
.warningInfoBox {
  position: absolute;
  z-index: 9999;
  top: px2vw(150);
  left: px2vw(500);
  width: px2vw(400);
  height: auto;
  border: 1px solid rgba(54, 155, 188, 1);
  background: linear-gradient(
    180deg,
    rgba(19, 92, 114, 0.71) 0%,
    rgba(11, 59, 73, 0.65) 17.16%,
    rgba(14, 92, 116, 0.49) 35.04%,
    rgba(14, 69, 86, 0.61) 64.84%,
    rgba(14, 50, 61, 0.69) 100%
  );
}
.warningInfoTitle {
  width: px2vw(400);
  height: px2vw(48);
  display: flex;
  align-items: center;
  color: rgba(227, 236, 255, 1);
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: px2vw(16);
  line-height: px2vw(24);
  background: linear-gradient(
    89.93deg,
    rgba(35, 105, 138, 0) 0.06%,
    rgba(43, 133, 175, 0.93) 10.86%,
    rgba(35, 105, 138, 1) 72.9%,
    rgba(35, 105, 138, 0) 98.55%
  );
  /* width: 388px;
  height: 54px; */
  border-width: 1px;
  border-style: solid;
  border-image-source: linear-gradient(
    90.01deg,
    rgba(255, 255, 255, 0) 0.01%,
    rgba(255, 255, 255, 0) 18.18%,
    rgba(255, 255, 255, 0) 99.66%
  );
  padding: 0px px2vw(15);
}
.checkListSec .el-input--mini .el-input__inner {
  width: px2vw(100);
  height: px2vw(28);
  font-size: px2vw(14) !important;
}
.checkList2Sec .el-input--mini .el-input__inner {
  width: px2vw(150) !important;
  height: px2vw(28) !important;
  font-size: px2vw(14) !important;
}
.el-radio__label {
  font-size: px2vw(14) !important;
  color: white !important;
}
.warningInfoMainBox {
  height: auto;
  width: 100%;
  /* background-color: #c5f3f8; */
}
.warningInfoMainBoxItem {
  height: px2vw(30);
  width: 100%;
  display: flex;
  margin-top: px2vw(5);
  /* background-color: #e7e2c0; */
}
.itemLeftBox {
  height: 100%;
  width: 30%;
  /* background-color: #c5f3f8; */
  line-height: px2vw(30);
  padding: 0px px2vw(15);
  text-align: right;
  color: rgba(198, 248, 255, 1);
  font-family: Microsoft YaHei;
  font-size: px2vw(16);
}
.itemRightBox {
  color: rgba(255, 255, 255, 1);
  font-family: Microsoft YaHei;
  font-size: px2vw(16);
  line-height: px2vw(30);
  width: 70%;
}
.layerControllBox {
  border: 1px solid #2386a5;
  position: absolute;
  pointer-events: auto;
  top: px2vw(130);
  right: px2vw(440);
  z-index: 999;
  width: px2vw(222);
  /* height: 178px; */
  /* background-image: url("../assets/Rectangle_19479.png"); */
  background: linear-gradient(
    180deg,
    rgba(19, 92, 114, 0.71) 0%,
    rgba(11, 59, 73, 0.65) 17.16%,
    rgba(14, 92, 116, 0.49) 35.04%,
    rgba(14, 69, 86, 0.61) 64.84%,
    rgba(14, 50, 61, 0.69) 100%
  );
  padding: px2vw(10) px2vw(10) px2vw(25) px2vw(10);
}
.layerControllTitle {
  background: linear-gradient(
    180deg,
    rgba(219, 249, 255, 1) 32.78%,
    rgba(169, 240, 255, 1) 78.3%
  );
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent;
  font-family: DingTalk JinBuTi;
  font-size: px2vw(18);
  /* padding: 5px 10px; */
}
.openBottomlaryerbtn {
  background: linear-gradient(
    180deg,
    rgba(219, 249, 255, 1) 32.78%,
    rgba(169, 240, 255, 1) 78.3%
  );
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent;
  font-family: DingTalk JinBuTi;
  font-size: px2vw(14);
}
.layerSelectBox {
  height: 20px;
  width: 100%;
  margin-top: px2vw(5);

  /* background-color: #c5f3f8; */
}
.mylayerSelectBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.el-radio {
  margin-right: px2vw(10) !important;
}

.el-radio__input.is-checked + .el-radio__label {
  color: #32dcfe !important;
}
/* 选中后小圆点的颜色 */
.el-radio__input.is-checked .el-radio__inner {
  background: #32dcfe !important;
  border-color: #32dcfe !important;
}
.el-radio__label {
  color: white !important;
}
.el-input__inner {
  background-color: #1e4e4e !important;
  color: white !important;
}
.el-checkbox {
  margin-right: px2vw(10) !important;
}
.el-checkbox__label {
  color: white !important;
}

.timelineBox {
  box-sizing: border-box;
  width: px2vw(860);
  height: px2vw(50);
  position: absolute;
  bottom: px2vw(180);

  left: px2vw(530);
  pointer-events: auto;
  z-index: 999;
  background: linear-gradient(
    90deg,
    rgba(0, 51, 51, 0.72) 0%,
    rgba(0, 149, 149, 0.43) 49.75%,
    rgba(0, 51, 51, 0.72) 100%
  );
  // transform: translateX(-430px);
  border: 2px solid #2386a5;
  display: flex;
}
.playBtnBox {
  height: px2vw(50);
  width: px2vw(50);
  /* background-color: #32dcfe; */
  display: flex;
  justify-content: center;
  align-items: center;
}
.isplayingBtn {
  width: px2vw(40);
  height: px2vw(40);
}
.el-select .el-input .el-select__caret {
  font-size: px2vw(14) !important;
}
.el-input--mini .el-input__icon {
  line-height: px2vw(28) !important;
}
.el-tag--small {
  height: px2vw(24) !important;

  padding: 0 px2vw(8) !important;
  line-height: px2vw(22) !important;
  font-size: px2vw(12) !important;
}
.timeline {
  height: px2vw(50);
  width: px2vw(780);
  // background-color: #2386a5;
  margin-left: px2vw(20);
}
.el-slider__marks-text {
  position: absolute;
  transform: translateX(-50%);
  font-size: px2vw(14) !important;
  color: #909399;
  margin-top: px2vw(15) !important;
}
.el-slider__button {
  width: px2vw(16) !important;
  height: px2vw(16) !important;
  border: px2vw(2) solid #409eff;
  background-color: #fff;
  border-radius: 50%;
  transition: 0.2s;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}
.el-slider__runway {
  width: 100%;
  height: px2vw(6) !important;
  margin: px2vw(16) 0 !important;
  background-color: #e4e7ed;
  border-radius: 3px;
  position: relative;
  cursor: pointer;
  vertical-align: middle;
}
.lendgenBox {
  /* height: 204px; */
  border: 1px solid rgba(74, 107, 108, 1);
  box-sizing: border-box;
  background: linear-gradient(
    180deg,
    rgba(19, 92, 114, 0.52) 0%,
    rgba(11, 59, 73, 0.47) 17.16%,
    rgba(14, 92, 116, 0.36) 35.04%,
    rgba(14, 69, 86, 0.45) 64.84%,
    rgba(14, 50, 61, 0.5) 100%
  );
  padding: px2vw(10) 0px;
}
.listNewBox {
  position: absolute;
  bottom: px2vw(10);
  right: px2vw(250);
  z-index: 999;
  width: px2vw(100);
}
.lendgenBoxTitle {
  height: px2vw(30);
  width: 100%;
  font-family: Microsoft YaHei UI;
  font-weight: bold;
  font-size: px2vw(14);
  color: white;
  text-align: center;
  line-height: px2vw(30);
}
.showNumSwitch {
  display: flex;
  justify-content: space-around;
  align-items: center;
  color: white;
  font-size: px2vw(12);
}
.el-switch__core {
  width: px2vw(40) !important;
  height: px2vw(20) !important;
}
.el-switch__core:after {
  content: "";
  position: absolute;
  top: 1px;
  left: 1px;
  border-radius: 100%;
  transition: all 0.3s;
  width: px2vw(16) !important;
  height: px2vw(16) !important;
  background-color: #fff;
}
.colorListBox {
  width: 100%;
  /* padding: 10px; */
  /* background-color: #32dcfe; */
}
.colorListBoxItem {
  height: px2vw(15);
  width: 100%;
  display: flex;
  justify-content: space-around;
  color: white;
  margin-top: px2vw(5);
}
.colorBox {
  width: 40%;
  height: px2vw(15);
  background-color: red;
}
.colorLable {
  height: px2vw(15);
  line-height: px2vw(15);
}
.optionSet {
  width: px2vw(100);
  height: px2vw(30);
  background: linear-gradient(
    180deg,
    rgba(47, 111, 115, 0.9) 0%,
    rgba(7, 22, 26, 0.5) 100%
  );
  margin-bottom: 5px;
  font-family: Microsoft YaHei UI;
  font-weight: bold;
  font-size: px2vw(14);
  color: white;
  text-align: center;
  line-height: px2vw(30);
}
.closeBoxImg {
  position: absolute;
  top: 0;
  right: 0;
  width: px2vw(30);
  height: px2vw(30);
}
.closeBoxImg3 {
  position: absolute;
  top: 0;
  right: 0;
  width: px2vw(30);
  height: px2vw(30);
  z-index: 10000;
}
.closeBoxImg2 {
  position: absolute;
  top: px2vw(15);
  right: 0;
  width: px2vw(30);
  height: px2vw(30);
  z-index: 9999;
}
.otherLaryerControllBox {
  height: px2vw(80);
  // width: px2vw(207);
  // background-color: #32dcfe;
  position: absolute;
  top: px2vw(400);
  right: px2vw(0);
  pointer-events: auto;
  display: flex;
  flex-direction: column;
  // align-content: flex-end;
  align-items: flex-end;
}
.myLaryerControllBox {
  height: px2vw(600);
  width: px2vw(307);
  pointer-events: auto;
  // background-color: #32dcfe;
  position: absolute;
  top: px2vw(150);
  right: px2vw(0);
  // z-index: 999;
  display: flex;
  flex-direction: column;
  // align-content: flex-end;
  align-items: flex-end;
}
.layerChooseBoxTitle {
  width: px2vw(100);
  height: px2vw(20);
  padding-right: px2vw(8);
  font-family: Microsoft YaHei UI;
  font-weight: bold;
  font-size: px2vw(14);
  line-height: px2vw(16);
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 1) 9.38%,
    rgba(135, 154, 181, 1) 90.62%
  );
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent;
  display: flex;
  align-items: center;
  // text-align: right;
  justify-content: end;
}
.layerradioBox {
  margin-top: px2vw(5);
  display: flex;
  justify-content: end;
}
.testRadio {
  display: block !important;
}
.layerCHooseItemBox {
  margin-top: px2vw(15);
  padding-right: px2vw(8);
}
.testradiobox {
  width: auto;
  height: px2vw(32);
  display: flex;
  align-items: center;
  padding: 0 px2vw(10);
  margin-top: px2vw(5);
  border-radius: px2vw(49);
  border: 1px solid rgba(74, 107, 108, 1);
  box-sizing: border-box;
  background: linear-gradient(
    180deg,
    rgba(19, 92, 114, 0.71) 0%,
    rgba(11, 59, 73, 0.65) 17.16%,
    rgba(14, 92, 116, 0.49) 35.04%,
    rgba(14, 69, 86, 0.61) 64.84%,
    rgba(14, 50, 61, 0.69) 100%
  );
  justify-content: end;
  // color:#ffffff59;
}
.testradiobox2 {
  color: white;
  width: auto;
  height: px2vw(32);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 px2vw(10);
  margin-top: px2vw(5);
  border-radius: px2vw(49);
  border: 1px solid rgba(74, 107, 108, 1);
  box-sizing: border-box;
  background: linear-gradient(
    180deg,
    rgba(19, 92, 114, 0.71) 0%,
    rgba(11, 59, 73, 0.65) 17.16%,
    rgba(14, 92, 116, 0.49) 35.04%,
    rgba(14, 69, 86, 0.61) 64.84%,
    rgba(14, 50, 61, 0.69) 100%
  );
  margin-left: px2vw(10);
}

.leaflet-popup-content-wrapper {
  background: linear-gradient(
    180deg,
    rgba(19, 92, 114, 1) 0%,
    rgba(11, 59, 73, 0.9) 17.16%,
    rgba(14, 92, 116, 0.9) 35.04%,
    rgba(14, 69, 86, 0.9) 64.84%,
    rgba(14, 50, 61, 0.9) 100%
  ) !important;
  color: white !important;
  border: 1px solid rgba(54, 155, 188, 1);
}
.showRadioLayer {
  height: px2vw(32);
  line-height: px2vw(32);
  // color: ;
  background: linear-gradient(
    180deg,
    rgba(19, 92, 114, 0.71) 0%,
    rgba(11, 59, 73, 0.65) 17.16%,
    rgba(14, 92, 116, 0.49) 35.04%,
    rgba(14, 69, 86, 0.61) 64.84%,
    rgba(14, 50, 61, 0.69) 100%
  );
  color: white;
  width: px2vw(32);
  text-align: center;
  font-size: px2vw(32);
  margin-top: px2vw(5);
  border-radius: 5px;
  margin-left: 5px;
}
.showWaringBoxBtn {
  height: px2vw(30);
  width: px2vw(30);
  position: absolute;
  left: 0;
  top: px2vw(100);
  z-index: 1000;
  background-color: #4985aa;
  border: 1px solid #afedf0;
  font-size: px2vw(30);
  text-align: center;
  line-height: px2vw(30);
  color: #afedf0;
  border-radius: 0px px2vw(5) px2vw(5) 0px;
}
.showWaringBoxBtn2 {
  height: px2vw(30);
  width: px2vw(30);
  position: absolute;
  left: 0;
  top: px2vw(400);
  z-index: 1000;
  background-color: #4985aa;
  border: 1px solid #afedf0;
  font-size: px2vw(30);
  text-align: center;
  line-height: px2vw(30);
  color: #afedf0;
  border-radius: 0px px2vw(5) px2vw(5) 0px;
}
.showWaringBoxBtn3 {
  height: px2vw(30);
  width: px2vw(30);
  position: absolute;
  left: 0;
  top: px2vw(650);
  z-index: 1000;
  background-color: #4985aa;
  border: 1px solid #afedf0;
  font-size: px2vw(30);
  text-align: center;
  line-height: px2vw(30);
  color: #afedf0;
  border-radius: 0px px2vw(5) px2vw(5) 0px;
}
.echartsBox {
  height: 300px;
  width: 700px;
  background: linear-gradient(
    180deg,
    rgba(19, 92, 114, 0.71) 0%,
    rgba(11, 59, 73, 0.65) 17.16%,
    rgba(14, 92, 116, 0.49) 35.04%,
    rgba(14, 69, 86, 0.61) 64.84%,
    rgba(14, 50, 61, 0.69) 100%
  );
  border: 1px solid rgba(54, 155, 188, 1);
  position: absolute;
  // top: 500px;
  // left: 500px;
  z-index: 9999;
  // padding: 10px;
}
// .EarthquakeMaker{

// }
@keyframes wxBlinking {
  from {
    width: 32px;
    height: 32px;
    opacity: 1;
  }
  to {
    width: 32px;
    height: 32px;
    opacity: 0;
  }
}
.optionSet2 {
  width: px2vw(100);
  height: px2vw(30);
  background: linear-gradient(
    180deg,
    rgba(47, 111, 115, 0.9) 0%,
    rgba(7, 22, 26, 0.5) 100%
  );
  margin-bottom: 5px;
  font-family: Microsoft YaHei UI;
  font-weight: bold;
  font-size: px2vw(14);
  color: white;
  text-align: center;
  line-height: px2vw(30);
  position: absolute;
  bottom: px2vw(50);
  right: px2vw(250);
  z-index: 9999;
}
.EarthquakeMaker {
  animation: wxBlinking 1s infinite alternate;
}
.timeLineTopBox {
  position: absolute;
  bottom: px2vw(235);
  left: px2vw(530);
  z-index: 999;
  width: px2vw(860);
  height: px2vw(60);
  border-radius: px2vw(4);
  border: px2vw(1) solid rgba(255, 255, 255, 0.2);
  box-sizing: border-box;
  background: rgba(1, 46, 47, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
}
.timeTitleBox {
  width: px2vw(60);
  height: px2vw(60);
  border-radius: px2vw(4) 0px 0px px2vw(4);
  border: px2vw(1) solid rgba(255, 255, 255, 0.2);
  box-sizing: border-box;
  background: rgba(9, 95, 98, 0.6);
  box-sizing: border-box;
  background: linear-gradient(
    180deg,
    rgba(219, 249, 255, 1) 32.78%,
    rgba(169, 240, 255, 1) 78.3%
  );
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent;
  font-family: "DingTalk JinBuTi";
  font-weight: 400;
  font-size: px2vw(18);
  line-height: 120.000005%;
  letter-spacing: 10%;
  display: flex;
  //  text-indent: 20px;
  align-items: center;
  text-align: center;
  padding: px2vw(10);
}
.timeIconBox {
  width: px2vw(48);
  height: px2vw(48);
  border-radius: 0px 0px 1px 1px;
  background: rgba(51, 101, 255, 1);
  margin-left: px2vw(6);
}
.timemainBox {
  width: px2vw(250);
  height: px2vw(46);
  // background-color: red;
  margin-left: px2vw(20);
}
.timemainBoxItem {
  height: px2vw(23);
  line-height: px2vw(23);
  color: rgba(255, 255, 255, 1);
  font-family: "Microsoft YaHei";
  font-weight: 400;
  font-size: px2vw(13);
}
.timeAreaBtn {
  width: px2vw(79);
  height: px2vw(37);
  background-image: url("../assets/Group_1321314701.png");
  background-size: 100% 100%;
  // background: linear-gradient(180deg, rgba(164, 245, 250, 1) 0%, rgba(220, 243, 247, 1) 100%);
  color: rgba(164, 245, 250, 1);
  font-family: "Microsoft YaHei";
  font-weight: 700;
  font-size: px2vw(12);
  text-align: center;
  line-height: px2vw(37);
  position: absolute;
  right: px2vw(10);
}
.warningBoxf22 {
  position: absolute;
  top: px2vw(80);
  /* left: 1490px; */
  left: px2vw(30);
  pointer-events: auto;
  /* background-color: aqua; */
  // background-color: red;
  width: px2vw(400);
  height: px2vw(150);
}
.warningMainBox33 {
  width: px2vw(400);
  height: px2vw(105);
  border-width: 1px;
  border-style: solid;
  border-image-source: linear-gradient(
    270deg,
    rgba(34, 67, 77, 0.6) 0%,
    rgba(29, 62, 70, 1) 100%
  );
  border-image-slice: 1;
  box-sizing: border-box;
  background: linear-gradient(
    270deg,
    rgba(17, 32, 37, 0.1) 0%,
    rgba(22, 39, 45, 0.5) 100%
  );
  padding: px2vw(5);
  background-image: url("../assets/00000_iSpt.png");
  background-size: contain;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  background-repeat: no-repeat;
  background-position: 0px 20px;
}
.warningMainBox33Item {
  width: 90%;
  height: px2vw(60);
  // border: 1px solid red;
  display: flex;
  // justify-content: space-evenly;
}
.waringtTitle {
  display: flex;
  width: 80%;
  justify-content: space-between;
  color: white;
  font-size: px2vw(12);
  margin-top: 10px;
}
.warningMainBox33Item .item1 {
  width: px2vw(60);
  height: px2vw(60);
  // border: 1px solid blue;
  background: linear-gradient(
    180deg,
    rgba(206, 238, 255, 1) 0%,
    rgba(0, 103, 199, 1) 100%
  );
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent;
  font-family: "DingTalk Sans";
  font-weight: 400;
  font-size: px2vw(28);
  line-height: px2vw(34);
  text-align: center;
  line-height: px2vw(60);
  margin-left: px2vw(8);
}
.warningMainBox33Item .item2 {
  line-height: px2vw(60);
  width: px2vw(60);
  height: px2vw(60);
  // border: 1px solid blue;
  margin-left: px2vw(32);
  text-align: center;
  background: linear-gradient(
    180deg,
    rgba(255, 254, 233, 1) 0%,
    rgba(214, 167, 0, 1) 100%
  );
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent;
  font-family: "DingTalk Sans";
  font-weight: 400;
  font-size: px2vw(28);
}
.warningMainBox33Item .item3 {
  line-height: px2vw(60);
  width: px2vw(60);
  text-align: center;
  height: px2vw(60);
  // border: 1px solid blue;
  margin-left: px2vw(25);
  background: linear-gradient(
    180deg,
    rgba(255, 222, 198, 1) 0%,
    rgba(201, 84, 0, 1) 100%
  );
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent;
  font-family: "DingTalk Sans";
  font-weight: 400;
  font-size: px2vw(28);
}
.warningMainBox33Item .item4 {
  line-height: px2vw(60);
  text-align: center;
  width: px2vw(60);
  height: px2vw(60);
  // border: 1px solid blue;
  margin-left: px2vw(28);
  background: linear-gradient(
    180deg,
    rgba(255, 211, 211, 1) 0%,
    rgba(221, 0, 0, 1) 100%
  );
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent;
  font-family: "DingTalk Sans";
  font-weight: 400;
  font-size: px2vw(28);
}
.mynewPopBox .leaflet-popup-content-wrapper {
  // border-radius: 4px;
  // border-width: 2px;
  // border-style: solid;
  // border-image-source: linear-gradient(
  //   180deg,
  //   rgba(64, 255, 255, 0.62) 0%,
  //   rgba(64, 255, 255, 0) 43.88%
  // );
  // border-image-slice: 1;
  // box-sizing: border-box;
  // background: rgba(2, 13, 17, 0.6);
  // box-shadow: 0px 0px 30px rgba(58, 211, 255, 0.3) inset,
  //   0px 0px 8px rgba(92, 184, 255, 0.24);
  // backdrop-filter: blur(10px);
  background-color: red !important;
}
.dizaiLedgon{
  height: px2vw(150);
  width: px2vw(140);
  position: absolute;
  bottom: px2vw(50);
  right: px2vw(100);
  z-index: 9999;
   background: linear-gradient(
    180deg,
    rgba(47, 111, 115, 0.9) 0%,
    rgba(7, 22, 26, 0.5) 100%
  );
}
.dizaiLedgonTitle{
  text-align: center;
  line-height: 30px;
  height: 30px;
  width: 100%;
  font-size: 12px;
  color: white;
}
.dizaiLedgonitem{
  height: 40px;
  width: 100%;
  // background-color: red;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.dizaiLedgonitemLeft{
  width: 30px;
  height: 30px;

}
.dizaiLedgonitemright{
  height: 30px;
  width: 90px;
  text-align: center;
  font-size: 10px;
  color: white;
  line-height: 30px;
}
// .warp {
//   height: 270px;
//   width: 360px;
//   margin: 0 auto;
//   overflow: hidden;
// }
</style>